import {
    Box,
    Button,
    CardMedia,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Modal,
    Radio,
    RadioGroup,
    Select,
    Step,
    StepLabel,
    Stepper,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    ThemeProvider,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
    createTheme,
    styled,
    FormHelperText,
    useMediaQuery
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import LogoutIcon from "@mui/icons-material/Logout";

import {
    Add as AddIcon,
    Delete as DeleteIcon,
    Edit as EditIcon,
    Link as LinkIcon,
} from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React, { useEffect, useState } from "react";
// import background from "../../../assests/images/mayaccountbg.png";
// import Colors from "../../../assests/style";
import { Controller, useForm } from "react-hook-form";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { SecondaryButton } from "../../../components/Buttons";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


import { Link, useLocation, useNavigate } from "react-router-dom";
// import OrderServices from "../../../services/OrderServices";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import VisibilityIcon from "@mui/icons-material/Visibility"

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import Images from "../../../assets/images";
import InputField2 from "../../../components/inputField2";
import SelectField from "../../../components/SelectField";
// import AuthServices from "../../../services/AuthServices";
// import OTPInput from "react-otp-input";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";




import { StepConnector, stepConnectorClasses } from "@mui/material";
import MultiSelectField from "../../../components/MultiSelect";
import instance from "../../../../axios";
import { ErrorToaster } from "../../../components/Toaster";
import AuthServices from "../../../api/VoucherServices";
import OrderServices from "../../../api/orderServices/order.index";
import { useAuth } from "../../../context/index";
import { width } from "@mui/system";
import { currencyType, currencyType2 } from "../../../utils";
const platformIcons = {
    facebook: <FacebookIcon sx={{ color: "#0BD1D1", fontSize: '43px' }} />,
    instagram: <InstagramIcon sx={{ color: "#0BD1D1", fontSize: '43px' }} />,
    twitter: <TwitterIcon sx={{ color: "#0BD1D1", fontSize: '43px' }} />,
    linkedin: <LinkedInIcon sx={{ color: "#0BD1D1", fontSize: '43px' }} />,
};
// custom connector
const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 0,
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
        borderColor: "#00C6FF", // active step connector
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        borderColor: "#00C6FF", // completed step connector
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#374e5b", // default (upcoming step)
        borderWidth: 1,
        minHeight: "40px",
    },
}));

const VendorForm = () => {


    const navigate = useNavigate()
    const [otp, setOtp] = useState("");
    const location = useLocation();
    console.log(location);
    const [open, setOpen] = useState(false);
    const [tabIndex1, setTabIndex1] = useState(0);
    const [currency, setCurrency] = useState('')
    const [country, setCountry] = useState(null)
    const [vendorData, setVendorData] = useState(null)

    const handleChange2 = (event, newValue) => {
        setTabIndex1(newValue);
    };
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [open2, setOpen2] = useState(false)
    const { userLogout2 } = useAuth();
    const [agree, setAgree] = useState(false)

    const handleVerify = () => {
        console.log("Entered OTP:", otp);
        // call your API here
    };
    const [activeStep, setActiveStep] = useState(location?.state ? location?.state : 0)
    const [formData, setFormData] = useState({})
    const [selectedCities, setSelectedCities] = useState([])

    const [selectedColors, setSelectedColors] = useState([]);

    const [uploadedData, setUploadedData] = useState([])
    const [selectedCsv, setSelectedCsv] = useState(null)

    // Template data for CSV download
    const templateData = [
        { size: "XS", chest: 18, length: 24.5, shoulder: 6 },
        { size: "S", chest: 20, length: 25.5, shoulder: 6 },
        { size: "M", chest: 22, length: 26.5, shoulder: 6 },
        { size: "L", chest: 24, length: 27.5, shoulder: 6 },
        { size: "XL", chest: 26, length: 28.5, shoulder: 6 },
        { size: "XXL", chest: 28, length: 29.5, shoulder: 6 },
        { size: "XXXL", chest: 30, length: 30.5, shoulder: 6 },
    ];


    // Function to download CSV template
    const downloadTemplate = () => {
        const headers = Object.keys(templateData[0])
        const csvContent = [
            headers.join(","),
            ...templateData.map((row) => headers.map((header) => `"${row[header]}"`).join(",")),
        ].join("\n")

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
        const link = document.createElement("a")
        const url = URL.createObjectURL(blob)
        link.setAttribute("href", url)
        link.setAttribute("download", "size_chart_template.csv")
        link.style.visibility = "hidden"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    // Function to handle CSV file upload
    const handleFileUpload = (event) => {
        const file = event.target.files[0];


        if (file && file.type === "text/csv") {
            const reader = new FileReader();
            setSelectedCsv(file);
            reader.onload = (e) => {
                const csvText = e.target.result;
                const lines = csvText.split("\n");

                // Extract headers
                const headers = lines[0]
                    .split(",")
                    .map((header) => header.replace(/"/g, "").trim());

                const data = [];

                for (let i = 1; i < lines.length; i++) {
                    if (lines[i].trim()) {
                        const values = lines[i]
                            .split(",")
                            .map((value) => value.replace(/"/g, "").trim());

                        const row = {};
                        headers.forEach((header, index) => {
                            let key = header.trim();

                            if (key.toLowerCase() === "length") key = "length";
                            if (key.toLowerCase() === "shoulder") key = "shoulder";
                            if (key.toLowerCase() === "chest") key = "chest";
                            if (key.toLowerCase() === "size") key = "size";

                            if (key !== "size") {
                                row[key] = values[index] ? parseFloat(values[index]) : 0;
                            } else {
                                row[key] = values[index] || "";
                            }
                        });

                        data.push(row);
                    }
                }

                setUploadedData(data);
                console.log("Updated CSV Data:", data);
            };

            reader.readAsText(file);
        } else {
            ErrorToaster('Only Csv files are allowed')
        }
    };


    const toggleColor = (color) => {
        setSelectedColors((prev) =>
            prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
        );
    };
    console.log(selectedColors);

    const getVendorDetail = async () => {



        try {



            const { data } = await AuthServices.getVendorDetail();
            console.log(data);
            let vendor = data?.vendor
            if (vendor) {
                setPageLoader(false)
            }
            setVendorData(vendor)
            setValue1('brandName', vendor?.name)
            setCountry(vendor?.country)
            getStates(vendor?.country)
            setCurrency(vendor?.currency ? vendor?.currency : 'USD')
            setLogo(vendor?.logo ? [vendor?.logo] : null)
            setValue1('email', vendor?.email)
            setValue1('contactPersonName', vendor?.cp_name)
            setValue1('phoneNumber', vendor?.phone)
            setValue1('website', vendor?.website)
            setValue1('address1', vendor?.address_1)
            setValue1('address2', vendor?.address_2)
            setValue1('zipCode', vendor?.zip)
            console.log(location?.state, 'locationlocationlocation');
            if (vendor?.profile_complete) {
                setAgree(true)
            }
            if (location?.state?.step) {
                setActiveStep(location?.state?.step)
            }
            else {
                console.log(vendor?.profile_complete, 'locationlocationlocation');

                if (vendor?.profile_complete) {
                    setAgree(true)
                    console.log(location, 'locationlocationlocation');

                    if (!location?.state?.edit) {
                        navigate('/vendor-detail')
                    }
                    else {
                        setActiveStep(location?.state?.step)
                    }

                }
                else {
                    setActiveStep(vendor?.active_step)
                }

            }

            setSelectedCity({ id: vendor?.city, name: vendor?.city })
            setSelectedState({ id: vendor?.state, name: vendor?.state })
            setSelectedCities(
                vendor?.operating_cities.map(state => ({
                    id: state,
                    name: state
                }))
            );
            setSelectedProductType({ id: vendor?.product_type, name: vendor?.product_type })
            setValue3('printingMethods', vendor?.printing_methods)
            setHalfTone(vendor?.half_tone_available ? "Yes" : "No")
            const mappedProducts = vendor?.products?.map((item, index) => ({
                sample_images: item?.sample_images,
                type: item?.type,
                fabrics: item?.fabrics,
                premium_fabrics: item?.premium_fabrics,
                adult_sizes: item?.adult_sizes,
                youth_sizes: item?.youth_sizes,
                colors: item?.colors,
                standardOneSide: item?.one_side_standard,
                standardDoubleSide: item?.double_side_standard,
                standardAdditional: item?.additional_standard,
                standardDescription: item?.description_standard,

                premiumOneSide: item?.one_side_premium,
                premiumDoubleSide: item?.double_side_premium,
                premiumAdditional: item?.additional_premium,
                premiumDescription: item?.description_premium,
                size_chart: item?.size_chart
            }));
            console.log(mappedProducts, 'mappedProductsmappedProducts');

            setProducts(mappedProducts)

            setSelectedStandardDays({ id: vendor?.shipping?.standard?.days, name: vendor?.shipping?.standard?.days })
            setSelectedPremiumDays({ id: vendor?.shipping?.premium?.days, name: vendor?.shipping?.premium?.days })
            setSelectedExpressDays({ id: vendor?.shipping?.express?.days, name: vendor?.shipping?.express?.days })
            setSelectedStates(vendor?.operating_states.map(state => ({
                id: state,
                name: state
            })))
            setValue5('standardInState', vendor?.shipping?.standard?.instate_price)
            setValue5('standardOutState', vendor?.shipping?.standard?.outstate_price)
            setValue5('standardShirts', vendor?.shipping?.standard?.quantity_limit)
            setValue5('premiumInState', vendor?.shipping?.premium?.instate_price)
            setValue5('premiumOutState', vendor?.shipping?.premium?.outstate_price)
            setValue5('premiumShirts', vendor?.shipping?.premium?.quantity_limit)
            setValue5('expressInState', vendor?.shipping?.express?.instate_price)
            setValue5('expressOutState', vendor?.shipping?.express?.outstate_price)
            setValue5('expressShirts', vendor?.shipping?.express?.quantity_limit)
            setUploadedImages5(vendor?.past_work)
            setSocialLinks(vendor?.social_medias.map(state => ({
                platform: { id: state?.type?.toLowerCase(), name: state?.type?.toLowerCase() },
                url: state?.link
            })))
            setValue6('businessDescription', vendor?.business_description)
            setValue7('taxId', vendor?.tax_number)
            setSelectedState2({ id: vendor?.state_incorporation, name: vendor?.state_incorporation })
            console.log(vendor?.return_document, 'asdasasdasd');

            setReturnDoc(vendor?.return_document ? [vendor?.return_document] : null)
            setValue8('printDays', vendor?.days_to_print)
            setValue8('supportContact', vendor?.support_email)
            console.log(location, 'state');




        } catch (error) {
            console.error("❌ API Error:", error);
        }
    };
    useEffect(() => {
        getPricing()
        getVendorDetail()
    }, [])



    const {
        register: register1,
        handleSubmit: handleSubmit1,
        formState: { errors: errors1 },
        setValue: setValue1,
        reset: reset1,
        watch: watch1
    } = useForm()

    const {
        register: register2,
        handleSubmit: handleSubmit2,
        formState: { errors: errors2 },
        reset: reset2,
    } = useForm()

    const {
        register: register3,
        handleSubmit: handleSubmit3,
        formState: { errors: errors3 },
        reset: reset3,
        control: control3,
        setValue: setValue3,
    } = useForm()

    const {
        register: register4,
        handleSubmit: handleSubmit4,
        formState: { errors: errors4 },
        setValue: setValue4,
        getValues: getValues4,
        reset: reset4,
    } = useForm()
    console.log(errors4, 'errors4');

    const {
        register: register5,
        handleSubmit: handleSubmit5,
        formState: { errors: errors5 },
        reset: reset5,
        setValue: setValue5,
        watch: watch5
    } = useForm()

    const {
        register: register6,
        handleSubmit: handleSubmit6,
        formState: { errors: errors6 },
        getValues: getValues6,
        setValue: setValue6,
        reset: reset6,
    } = useForm()
    console.log(errors6, 'errors6errors6');

    const {
        register: register7,
        handleSubmit: handleSubmit7,
        formState: { errors: errors7 },
        setValue: setValue7,
        reset: reset7,
    } = useForm()

    const {
        register: register8,
        handleSubmit: handleSubmit8,
        formState: { errors: errors8 },
        reset: reset8,
        setValue: setValue8,
    } = useForm()
    console.log(errors8, 'errors8errors8')
    const steps = [
        "Merchant Details",
        "Operating Region",
        "Product Types Offered",
        "Product Setup",
        "Shipping Details",
        "Marketing Material",
        "Taxation Details",
        "Other Detail",
    ]

    const [partnerModal, setPartnerModal] = useState(false)
    const [showPasswordLogin, setShowPasswordLogin] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showPassword2, setShowPassword2] = useState(false)
    const [otpScreen, setOtpScreen] = useState(false)
    const [selectedState, setSelectedState] = useState(null)
    const [selectedState2, setSelectedState2] = useState(null)
    const [selectedStates, setSelectedStates] = useState([])
    const [selectedCity, setSelectedCity] = useState(null)
    const [terms, setTerms] = useState(false)
    const [selectedProductType, setSelectedProductType] = useState(null)
    const [selectedProductType2, setSelectedProductType2] = useState(null)
    const [selectedStandardDays, setSelectedStandardDays] = useState(null)
    const [selectedPremiumDays, setSelectedPremiumDays] = useState(null)
    const [selectedExpressDays, setSelectedExpressDays] = useState(null)
    const [selectedPlatform, setSelectedPlatform] = useState(null)
    const [selectedFabrics, setSelectedFabrics] = useState([])
    const [selectedFabrics2, setSelectedFabrics2] = useState([])
    const [selectedAdultSizes, setSelectedAdultSizes] = useState([])
    const [selectedYouthSizes, setSelectedYouthSizes] = useState([])
    const [products, setProducts] = useState([])
    const [editState, setEditState] = useState(false)
    const [halfTone, setHalfTone] = useState(false)
    // State to store added social links
    const [socialLinks, setSocialLinks] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null)



    // Temporary state for the inputs
    const [socialPlatform, setSocialPlatform] = useState("");
    const [socialUrl, setSocialUrl] = useState("");

    // Add new link
    const handleAddSocialLink = () => {
        const url = getValues6('socialUrl');

        if (!selectedPlatform || !url) return ErrorToaster(`Fields can not be empty.`);

        // Check if platform already exists
        const isAlreadyAdded = socialLinks.some(
            (link) => link.platform.name.toLowerCase() === selectedPlatform.name.toLowerCase()
        );

        if (isAlreadyAdded) {
            // You can show an error using a toast, alert, or custom error state
            ErrorToaster(`${selectedPlatform.name} is already added.`);
            return;
        }

        // Create new platform object
        const newPlatform = {
            id: selectedPlatform.id,
            name: selectedPlatform.name,
            icon: selectedPlatform.icon,
        };

        // Add new platform link
        setSocialLinks((prev) => [
            ...prev,
            {
                platform: newPlatform,
                url,
            },
        ]);

        // Reset inputs
        setSelectedPlatform(null)
        setValue6("socialPlatform", '');
        setValue6("socialUrl", '');
    };


    console.log(socialLinks, 'socialLinks222');


    // Edit existing link
    const handleEditSocialLink = (index) => {
        console.log(socialLinks, 'socialLinkssocialLinkssocialLinks');
        console.log(index, 'socialLinkssocialLinkssocialLinks');
        const link = socialLinks[index];
        console.log(link, 'socialLinkssocialLinkssocialLinks');

        setSocialPlatform(link.platform);
        setSocialUrl(link.url);

        // remove old one, will be re-added when saved
        // setSocialLinks((prev) => prev.filter((_, i) => i !== index));
    };

    // Delete existing link
    const handleDeleteSocialLink = (index) => {
        setSocialLinks((prev) => prev.filter((_, i) => i !== index));
    };
    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        reset
    } = useForm();
    const [successMessage, setSuccessMessage] = useState(null);
    const [colors, setColors] = useState([])
    const [states, setStates] = useState([])

    const [file, setFile] = useState(null);
    const [pageLoader, setPageLoader] = useState(true)

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const getPricing = async () => {
        try {
            let params = {};
            const { data } = await OrderServices.getPricing(params);
            console.log(data?.pricing?.shirt_colors);
            setColors(data?.pricing?.shirt_colors)



        } catch (error) {
            console.log(error);
        } finally {
        }
    };
    const getStates = async (country) => {
        try {
            let params = { country: country };
            const { data } = await OrderServices.getStates(params);
            console.log(data, 'countries');
            setStates(
                data?.states?.map((item, index) => ({
                    id: index,
                    name: item
                }))
            );





        } catch (error) {
            console.log(error);
        } finally {
        }
    };
    const [cities, setCities] = useState([])
    const [cities2, setCities2] = useState([])
    const getCities = async (id) => {
        try {
            let params = {
                country: country,
                state: id

            };
            const { data } = await OrderServices.getCities(params);
            console.log(data, 'cities');
            setCities(
                data?.cities?.map((item, index) => ({
                    id: index,
                    name: item
                }))
            );




        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    const getCities2 = async (value) => {
        console.log(value, 'valuevalue');
        const updated = value?.map(item => ({
            ...item,
            state: item.value?.join(',') || ''
        }));
        try {
            let params = {
                country: country,
                state: value.map(item => item.name).join(',')

            };
            const { data } = await OrderServices.getCities(params);
            console.log(data, 'cities');
            setCities2(
                data?.cities?.map((item, index) => ({
                    id: index,
                    name: item
                }))
            );




        } catch (error) {
            console.log(error);
        } finally {
        }
    };
    const addProductSubmit = async () => {
        console.log(products, 'products');

        const mappedProducts = products?.map((item, index) => ({
            sample_images: item?.sample_images,
            type: item?.type,
            fabrics: item?.fabrics,
            adult_sizes: item?.adult_sizes,
            youth_sizes: item?.youth_sizes,
            colors: item?.colors,
            premium_fabrics: item?.premium_fabrics,
            one_side_standard: item?.standardOneSide,           // or item.id if you want unique keys
            double_side_standard: item?.standardDoubleSide,    // remap fabric → name
            additional_standard: item?.standardAdditional,
            description_standard: item?.standardDescription,
            one_side_premium: item?.premiumOneSide,           // or item.id if you want unique keys
            double_side_premium: item?.premiumDoubleSide,    // remap fabric → name
            additional_premium: item?.premiumAdditional,
            description_premium: item?.premiumDescription,
            size_chart: item?.size_chart,
        }));

        try {

            let obj = {
                products: mappedProducts,
                active_step: 4
            }





            console.log(obj);

            const data = await AuthServices.VendorForm(obj)
            console.log(data)
            if (data) {
                setFormData((prev) => ({ ...prev, ...formData }))
                setActiveStep(4)

            }
        } catch (error) {
            console.log(error)
        }


    }

    const onSubmit1 = async (formData) => {
        console.log("Step 1 formData:", formData)


        try {



            let obj = {
                brand_name: formData.name,
                email: formData.email,
                phone: formData?.phoneNumber,
                logo: logo[0],
                cp_name: formData?.contactPersonName,
                website: formData?.website,
                address_1: formData?.address1,
                address_2: formData?.address2,
                state: selectedState?.name,
                city: selectedCity?.name,
                zip: formData?.zipCode,
                active_step: 1
            }



            console.log(obj, 'obj');

            const data = await AuthServices.VendorForm(obj)
            console.log(data)
            if (data) { }
            setFormData((prev) => ({ ...prev, ...formData }))
            setActiveStep(1)


        } catch (error) {
            console.log(error)
        }

    }


    const onSubmit2 = async (formData) => {
        console.log("Step 2 formData:", formData)

        try {



            let obj = {
                operating_cities: selectedCities?.map(state => state.name),
                operating_states: selectedStates?.map(state => state.name),
                active_step: 2

            }



            console.log(obj);

            const data = await AuthServices.VendorForm(obj)
            console.log(data)
            if (data) {
                setFormData((prev) => ({ ...prev, ...formData }))
                setActiveStep(2)

            }
        } catch (error) {
            console.log(error)
        }
    }

    const onSubmit3 = async (formData) => {
        console.log("Step 3 formData:", formData)
        try {



            let obj = {
                product_type: selectedProductType?.name,
                printing_methods: formData?.printingMethods,
                half_tone_available: halfTone == "Yes" ? true : false,
                active_step: 3

            }



            console.log(obj);

            const data = await AuthServices.VendorForm(obj)
            console.log(data)
            if (data) {
                setFormData((prev) => ({ ...prev, ...formData }))
                setActiveStep(3)

            }
        } catch (error) {
            console.log(error)
        }


    }


    console.log(errors4);

    const onSubmit4 = (data) => {
        console.log(data);

        // Merge states with form da
        // logta
        const finalData = {
            ...data,
            sample_images: uploadedImages4,
            type: selectedProductType2?.name,
            fabrics: selectedFabrics?.map(state => state.name),
            premium_fabrics: selectedFabrics2?.map(state => state.name),
            adult_sizes: selectedAdultSizes?.map(state => state.name),
            youth_sizes: selectedYouthSizes?.map(state => state.name),
            size_chart: uploadedData,
            colors: selectedColors,
        };
        setSelectedProductType2(null)
        setSelectedFabrics([])
        setSelectedFabrics2([])
        setSelectedAdultSizes([])
        setSelectedYouthSizes([])
        setSelectedColors([])
        setUploadedImages4([])
        setSelectedCsv(null)
        setUploadedData([])
        console.log("Step 4 Final Data:", finalData);


        setProducts((prev) => [...prev, finalData]);

        // keep step unchanged as you requested (not moving to next step here)
        reset4();
    };
    const onSubmit4Update = (data, index) => {
        // Merge states with form data
        const finalData = {
            ...data,
            sample_images: uploadedImages4,
            type: selectedProductType2?.name,
            fabrics: selectedFabrics?.map(state => state.name),
            premium_fabrics: selectedFabrics2?.map(state => state.name),
            adult_sizes: selectedAdultSizes?.map(state => state.name),
            youth_sizes: selectedYouthSizes?.map(state => state.name),
            size_chart: uploadedData,
            colors: selectedColors,
        };
        setUploadedImages4([])
        console.log("Step 4 Final Data (Update):", finalData);
        setSelectedProductType2(null)
        setSelectedFabrics([])
        setSelectedFabrics2([])
        setSelectedAdultSizes([])
        setSelectedYouthSizes([])
        setSelectedColors([])
        setUploadedData([])
        setSelectedCsv(null)
        // Update product at given index instead of adding new
        setProducts((prev) =>
            prev.map((item, i) => (i === index ? finalData : item))
        );
        setEditState(false)

        // Reset form
        reset4();
    };

    console.log(products, 'products');


    const onSubmit5 = async (formData) => {
        console.log("Step 5 formData:", formData)
        try {

            const cleanValue = (val) => (val === "" || val === undefined ? null : val);




            let obj = {
                shipping: {
                    standard: {
                        days: cleanValue(selectedStandardDays?.name),
                        instate_price: cleanValue(formData?.standardInState),
                        outstate_price: cleanValue(formData?.standardOutState),
                        quantity_limit: cleanValue(formData?.standardShirts),
                    },
                    premium: {
                        days: cleanValue(selectedPremiumDays?.name),
                        instate_price: cleanValue(formData?.premiumInState),
                        outstate_price: cleanValue(formData?.premiumOutState),
                        quantity_limit: cleanValue(formData?.premiumShirts),
                    },
                    express: {
                        days: cleanValue(selectedExpressDays?.name),
                        instate_price: cleanValue(formData?.expressInState),
                        outstate_price: cleanValue(formData?.expressOutState),
                        quantity_limit: cleanValue(formData?.expressShirts),
                    },
                },

                active_step: 5

            }



            console.log(obj);

            const data = await AuthServices.VendorForm(obj)
            console.log(data)
            if (data) {
                setFormData((prev) => ({ ...prev, ...data }))
                setActiveStep(5)

            }
        } catch (error) {
            console.log(error)
        }


    }

    const onSubmit6 = async (formData) => {
        console.log("socialLinks", socialLinks)
        try {



            let obj = {
                business_description: formData?.businessDescription,
                social_medias: socialLinks?.map((item, index) => ({

                    type: item.platform?.name,
                    link: item.url
                })),
                past_work: uploadedImages5,
                active_step: 6
            }







            const data = await AuthServices.VendorForm(obj)
            console.log(data)
            if (data) {
                setFormData((prev) => ({ ...prev, ...formData }))
                setActiveStep(6)
            }
        } catch (error) {
            console.log(error)
        }


    }

    const onSubmit7 = async (formData) => {
        console.log("Step 7 formData:", formData)

        try {



            let obj = {
                tax_number: formData?.taxId,
                state_incorporation: selectedState2?.name ? selectedState2?.name : '',
                active_step: 7
            }







            const data = await AuthServices.VendorForm(obj)
            console.log(data)
            if (data) {
                setFormData((prev) => ({ ...prev, ...formData }))
                setActiveStep(7)
            }
        } catch (error) {
            console.log(error)
        }

    }

    const onSubmit8 = async (formData) => {
        console.log("Step 8 formData:", formData)


        console.log("Step 7 formData:", formData)

        try {



            let obj = {
                tax_number: formData?.businessDescription,
                state_incorporation: selectedState2?.id,
                support_email: formData?.supportContact,
                days_to_print: formData?.printDays,
                return_document: returnDoc[0],
                active_step: 8,
                profile_complete: true
            }







            const data = await AuthServices.VendorForm(obj)
            console.log(data)
            if (data) {
                navigate('/vendor-detail')
            }
        } catch (error) {
            console.log(error)
        }


    }
    const [progress, setProgress] = useState(0);
    const [loader, setLoader] = useState(false)
    const [uploadedImages4, setUploadedImages4] = useState([])
    const [uploadedImages5, setUploadedImages5] = useState([])
    const [logo, setLogo] = useState(null)
    const [returnDoc, setReturnDoc] = useState(null)
    const [loading, setLoading] = useState(false)

    // Handle multi upload selection
    const handleImageUpload4 = (event) => {
        setLoader(true);
        const files = Array.from(event.target.files); // Convert FileList to Array

        // Build docs array
        const docs = files.map((file) => ({
            name: file?.name,
            file: "",
            type: file?.type.split("/")[1],
            size: file.size,
            isUpload: false,
        }));

        // Upload each file
        Promise.all(files.map((file, idx) => handleUpload4(file, docs, idx)))
            .then((urls) => {
                setUploadedImages4(urls.filter(Boolean))
                console.log("All Uploaded URLs:", urls.filter(Boolean)); // console only successful URLs
                setLoader(false);
            })
            .catch((err) => {
                console.error("Upload failed:", err);
                setLoader(false);
            });
    };

    // Upload function (supports index for docs array)
    const handleUpload4 = async (file, docs, index) => {
        setProgress(0);
        try {
            const formData = new FormData();
            formData.append("image", file);

            const { data } = await instance.post("/system/uploadImage", formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );
                    setProgress(percentCompleted);
                },
            });

            if (data) {
                docs[index].isUpload = true;
                docs[index].file = data?.data?.nations;
                console.log("File Uploaded:", docs[index]);
                console.log("File URL:", data?.data?.path);

                return data?.data?.path; // return single uploaded URL
            }
        } catch (error) {
            ErrorToaster(error);
            return null;
        }
    };
    const handleImageUpload = (event) => {

        setLoader(true);
        const files = Array.from(event.target.files); // Convert FileList to Array

        // Build docs array
        const docs = files.map((file) => ({
            name: file?.name,
            file: "",
            type: file?.type.split("/")[1],
            size: file.size,
            isUpload: false,
        }));

        // Upload each file
        Promise.all(files.map((file, idx) => handleUpload(file, docs, idx)))
            .then((urls) => {
                setLogo(urls.filter(Boolean))
                console.log("All Uploaded URLs:", urls.filter(Boolean)); // console only successful URLs
                setLoader(false);
            })
            .catch((err) => {
                console.error("Upload failed:", err);
                setLoader(false);
            });
    };
    const premiumDays = watch5("premiumDays");
    const premiumInState = watch5("premiumInState");
    const premiumOutState = watch5("premiumOutState");
    const premiumShirts = watch5("premiumShirts");

    const anyFieldFilled =
        premiumDays || premiumInState || premiumOutState || premiumShirts;
    const expressDays = watch5("expressDays");
    const expressInState = watch5("expressInState");
    const expressOutState = watch5("expressOutState");
    const expressShirts = watch5("expressShirts");

    const anyExpressFilled =
        expressDays || expressInState || expressOutState || expressShirts;



    // Upload function (supports index for docs array)
    const handleUpload = async (file, docs, index) => {
        setProgress(0);
        try {
            const formData = new FormData();
            formData.append("image", file);

            const { data } = await instance.post("/system/uploadImage", formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );
                    setProgress(percentCompleted);
                },
            });

            if (data) {
                docs[index].isUpload = true;
                docs[index].file = data?.data?.nations;
                console.log("File Uploaded:", docs[index]);
                console.log("File URL:", data?.data?.path);

                return data?.data?.path; // return single uploaded URL
            }
        } catch (error) {
            ErrorToaster(error);
            return null;
        }
    };

    const handleDocUpload = (event) => {
        setReturnDoc(null)
        setLoader(true);
        const files = Array.from(event.target.files); // Convert FileList to Array

        // Build docs array
        const docs = files.map((file) => ({
            name: file?.name,
            file: "",
            type: file?.type.split("/")[1],
            size: file.size,
            isUpload: false,
        }));

        // Upload each file
        Promise.all(files.map((file, idx) => handleUploadPdf(file, docs, idx)))
            .then((urls) => {
                console.log(urls.filter(Boolean));
                urls
                    .filter(Boolean)
                    .map(item => {
                        return process.env.REACT_APP_BASE_URL + item;
                    });

                setReturnDoc(urls
                    .filter(Boolean)
                    .map(item => {
                        return process.env.REACT_APP_BASE_URL + item;
                    })
                )
                console.log("All Uploaded URLs:", urls.filter(Boolean)); // console only successful URLs
                setLoader(false);
            })
            .catch((err) => {
                console.error("Upload failed:", err);
                setLoader(false);
            });
    };

    // Upload function (supports index for docs array)
    const handleUploadPdf = async (file, docs, index) => {
        setProgress(0);
        try {
            const formData = new FormData();
            formData.append("document", file);

            const { data } = await instance.post("/system/upload", formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );
                    setProgress(percentCompleted);
                },
            });

            if (data) {
                docs[index].isUpload = true;
                docs[index].file = data?.data?.nations;
                console.log("File Uploaded:", docs[index]);
                console.log("File URL:", data?.data?.path);

                return data?.data?.path; // return single uploaded URL
            }
        } catch (error) {
            ErrorToaster(error);
            return null;
        }
    };
    // Handle multi upload selection
    const handleImageUpload5 = (event) => {
        setLoader(true);
        const files = Array.from(event.target.files); // Convert FileList to Array

        // Build docs array
        const docs = files.map((file) => ({
            name: file?.name,
            file: "",
            type: file?.type.split("/")[1],
            size: file.size,
            isUpload: false,
        }));

        // Upload each file
        Promise.all(files.map((file, idx) => handleUpload5(file, docs, idx)))
            .then((urls) => {
                setUploadedImages5(urls.filter(Boolean))
                console.log("All Uploaded URLs:", urls.filter(Boolean)); // console only successful URLs
                setLoader(false);
            })
            .catch((err) => {
                console.error("Upload failed:", err);
                setLoader(false);
            });
    };

    // Upload function (supports index for docs array)
    const handleUpload5 = async (file, docs, index) => {
        setProgress(0);
        try {
            const formData = new FormData();
            formData.append("image", file);

            const { data } = await instance.post("/system/uploadImage", formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );
                    setProgress(percentCompleted);
                },
            });

            if (data) {
                docs[index].isUpload = true;
                docs[index].file = data?.data?.nations;
                console.log("File Uploaded:", docs[index]);
                console.log("File URL:", data?.data?.path);

                return data?.data?.path; // return single uploaded URL
            }
        } catch (error) {
            ErrorToaster(error);
            return null;
        }
    };

    const theme = createTheme({
        typography: {
            fontFamily: "Poppins, sans-serif", // You can change this to your preferred font
        },
        components: {
            MuiStepLabel: {
                styleOverrides: {
                    label: {
                        color: "rgba(255, 255, 255, 0.7)",
                        fontFamily: "Poppins, sans-serif",
                        "&.Mui-active": {
                            color: "#ffffff",
                        },
                        "&.Mui-completed": {
                            color: "#ffffff",
                        },
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        "& .MuiInputBase-root": {
                            color: "white", // Text color,
                            fontFamily: "Poppins, sans-serif",
                        },
                        "& .MuiInputLabel-root": {
                            color: "white", // Label color
                        },
                        "& .MuiInput-underline:before": {
                            borderBottomColor: "white", // Underline color when unfocused
                        },
                        "& .MuiInput-underline:after": {
                            borderBottomColor: "white", // Underline color when focused
                        },
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                borderColor: "white", // Border color when unfocused
                            },
                            "&:hover fieldset": {
                                borderColor: "white", // Border color on hover
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "white", // Border color when focused
                            },
                        },
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        color: "white", // Text color for input
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        borderColor: "white", // Border color for input
                    },
                    root: {
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "white",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "white",
                        },
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: "white", // Text color for label
                        borderColor: "white",
                        "&.Mui-focused": {
                            color: "white",
                        },
                    },
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        color: "black", // Text color for menu items
                        backgroundColor: "white", // Background color for menu items
                        "&.Mui-selected": {
                            backgroundColor: "rgba(255, 255, 255, 0.2)", // Background color for selected item
                        },
                        "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.1)", // Background color for hover
                        },
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: "white", // Color for dropdown arrow
                    },
                },
            },
        },
        palette: {
            primary: {
                main: "#1976d2",
            },
            background: {
                default: "#333333",
            },
        },
    });
    const isMobile = useMediaQuery(theme.breakpoints.down("md")); // true if screen ≤ 600px
    if (pageLoader) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "#0F172A",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                }}
            >
                <img
                    src={Images.loader}
                    alt="Loading..."
                    style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "contain",
                    }}
                />
            </div>
        );
    }




    return (
        <div style={{ background: '#0F172A' }}>

            <Dialog open={open} onClose={handleClose}
                PaperProps={{
                    sx: {
                        backgroundColor: "#1a2537", // Set dialog background to black
                        color: "white", // Make sure text stays visible
                        borderRadius: 3,
                    },
                }}

                maxWidth="md" fullWidth>

                <DialogContent>
                    <Box sx={{ mt: 3 }}> <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }} > Chart Table Size In Inches </Typography>
                        <Box sx={{ border: "1px solid rgba(255,255,255,0.3)", borderRadius: 2, overflow: "hidden", }} >
                            <table style={{ width: "100%", borderCollapse: "collapse", color: "white", }} >
                                <thead>
                                    <tr > <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Size</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Chest</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Length</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Shoulder</th> </tr> </thead>

                                <tbody>
                                    {uploadedData?.length > 0 &&
                                        uploadedData?.map((row, i) => (
                                            <tr
                                                key={i}
                                                style={{ borderTop: "1px solid rgba(255,255,255,0.2)" }}
                                            >
                                                {/* Map over the values of each object */}
                                                {Object.values(row).map((col, j) => (
                                                    <td key={j} style={{ padding: "10px", fontSize: "14px" }}>
                                                        {col}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                </tbody>
                            </table> </Box> </Box>
                </DialogContent>
            </Dialog>
            <Dialog
                open={terms}
                onClose={() => setTerms(false)}
                maxWidth="md"
                PaperProps={{
                    sx: {
                        backgroundColor: "#1a2537",
                        color: "white",
                        borderRadius: 3,
                        width: "600px",
                    },
                }}
            >


                {/* Tabs */}
                <Tabs
                    value={tabIndex1}
                    onChange={handleChange2}
                    centered
                    sx={{
                        "& .MuiTab-root": { color: "white" },
                        "& .Mui-selected": { color: "#00BCD4 !important" },
                        "& .MuiTabs-indicator": { backgroundColor: "#00BCD4" },
                    }}
                >
                    <Tab label="Terms & Conditions" />
                    <Tab label="Privacy Policy" />
                </Tabs>

                {/* Content */}
                <DialogContent dividers>
                    {tabIndex1 === 0 && (
                        <Box>
                            <Typography variant="body1" sx={{ color: "white" }}>
                                Here are the Terms and Conditions.
                                You can add your terms content here...
                            </Typography>
                        </Box>
                    )}
                    {tabIndex1 === 1 && (
                        <Box>
                            <Typography variant="body1" sx={{ color: "white" }}>
                                Here is the Privacy Policy.
                                You can add your privacy policy content here...
                            </Typography>
                        </Box>
                    )}
                </DialogContent>

                {/* Buttons */}
                <DialogActions sx={{ display: "flex", justifyContent: "center", pb: 3 }}>
                    <Button
                        onClick={() => {
                            setAgree(true)
                            setTerms(false)
                        }}
                        variant="contained"
                        sx={{
                            background: "#00BCD4",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: "#101A33",
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": { background: "#00ACC1" },
                        }}
                    >
                        Accept
                    </Button>
                    <Button
                        onClick={() => setTerms(false)}
                        variant="contained"
                        sx={{
                            background: "#00BCD4",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: "#101A33",
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": { background: "#00ACC1" },
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open2}
                onClose={() => setOpen2(false)}
                maxWidth="md"
                PaperProps={{
                    sx: {
                        backgroundColor: "#1a2537", // Set dialog background to black
                        color: "white", // Make sure text stays visible
                        borderRadius: 3,
                        width: '400px',

                    },
                }}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"

            >
                <DialogTitle sx={{ textAlign: 'center' }} id="confirm-dialog-title">Are You Sure?</DialogTitle>

                <DialogActions sx={{ display: 'flex', justifyContent: 'center', pb: 3 }}>
                    <Button
                        onClick={() => {
                            setOpen2(false)
                            userLogout2()

                        }
                        }
                        variant="contained"

                        sx={{
                            background: "#00BCD4",
                            color: "white",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: '#101A33',
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": {
                                background: "#00ACC1",
                            },
                        }}

                    >
                        Yes
                    </Button>
                    <Button
                        onClick={() => setOpen2(false)}
                        variant="contained"

                        sx={{
                            background: "#00BCD4",
                            color: "white",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: '#101A33',
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": {
                                background: "#00ACC1",
                            },
                        }}

                    >
                        No
                    </Button>


                </DialogActions>
            </Dialog>
            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: { lg: "300px", md: '300px', sm: '150px', xs: '150px' },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    position: "relative",
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, pl: { xs: 0, md: 3 }, mb: 1 }}>
                    <IconButton sx={{ color: "#00BCD4" }} onClick={() => navigate(-1)}>
                        <ArrowBackIcon sx={{ width: { xs: 18, sm: 22, md: 25 } }} />
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    <Box
                        component={"p"}
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "35px", xs: "18px" },
                            textAlign: "center",
                            fontFamily: "Maven Pro, sans-serif !important",
                        }}
                    >
                        {" "}
                        Vendor {" "}
                    </Box>
                    <Box
                        component={"span"}
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "35px", xs: "18px" },
                            textAlign: "center",
                            fontFamily: "Maven Pro, sans-serif !important",
                        }}
                    >
                        {" "}
                        Registration{" "}
                    </Box>
                    <Box
                        component={"span"}
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "35px", xs: "18px" },
                            textAlign: "center",
                            fontFamily: "Maven Pro, sans-serif !important",
                        }}
                    >
                        {" "}
                        Form{" "}
                    </Box>
                    {/* <p style={{ fontSize: '25px', textAlign: 'center', color: 'white', fontFamily: "Noto Sans, sans-serif", }}>Homepage || <span style={{ color: Colors.secondary }}>Contact Us</span></p> */}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, pr: { xs: 0, md: 3 }, mb: 1 }}>

                    <IconButton sx={{ color: '#00BCD4' }} onClick={() => setOpen2(true)}>
                        <LogoutIcon sx={{ width: { xs: 18, sm: 22, md: 25 } }} />
                    </IconButton>
                </Box>
            </Box>

            <Box component={"section"} sx={{
                py: 8,
                display: 'flex', justifyContent: 'center',
                backgroundImage: `url(${Images.frameBg})`,
                backgroundSize: "cover", // Adjust the image size
                backgroundPosition: "center", // Position the image
                backgroundRepeat: "no-repeat", // Avoid repeating the image,


            }}>
                {console.log(errors1)}
                <Box sx={{ width: { xs: '95%', md: '80%' } }}>
                    <Box sx={{ margin: "0 auto" }}>
                        <Grid container spacing={4}>
                            {/* Stepper Sidebar */}
                            <Grid item xs={12} md={3} lg={3}>
                                <Box
                                    sx={{
                                        background: "rgba(15, 23, 42, 0.8)",
                                        borderRadius: 2,
                                        p: 2,

                                    }}
                                >


                                    <Stepper
                                        activeStep={activeStep}
                                        orientation={isMobile ? 'horizontal' : "vertical"}
                                        sx={{ overflowX: isMobile ? 'scroll' : '' }}
                                        connector={<CustomConnector />}
                                    >
                                        {steps.map((label, index) => (
                                            <Step key={label} completed={index < activeStep}>
                                                <StepLabel
                                                    sx={{ padding: 0, width: 'max-content' }}
                                                    StepIconComponent={() => (
                                                        <Box
                                                            sx={{
                                                                width: 25,
                                                                height: 25,
                                                                borderRadius: "50%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                fontWeight: "bold",
                                                                color: "white",
                                                                fontSize: "16px",
                                                                backgroundColor:
                                                                    index === activeStep
                                                                        ? "#00C6FF" // current step
                                                                        : index < activeStep
                                                                            ? "#00C6FF" // completed step (green)
                                                                            : "#4A5A63", // upcoming step
                                                                border:
                                                                    index === activeStep
                                                                        ? "1px solid #00C6FF"
                                                                        : index < activeStep
                                                                            ? "1px solid #00C6FF"
                                                                            : "1px solid #00C6FF",
                                                            }}
                                                        >
                                                            {index < activeStep ? <CheckIcon sx={{ fontSize: 18 }} /> : index + 1}
                                                        </Box>
                                                    )}
                                                >
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                        <Typography
                                                            onClick={() => {
                                                                if (vendorData?.profile_complete) {
                                                                    setActiveStep(index)
                                                                }
                                                            }}
                                                            variant="body2"
                                                            sx={{
                                                                color: "white",
                                                                fontWeight: index === activeStep ? "bold" : 400,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            {label}
                                                        </Typography>
                                                    </Box>
                                                </StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>

                                </Box>
                            </Grid>

                            {/* Form Content */}
                            <Grid item xs={12} md={9} lg={9}>
                                <Box
                                    sx={{

                                    }}
                                >
                                    {activeStep === 0 && (
                                        <Box>
                                            <form onSubmit={handleSubmit1(onSubmit1)} >
                                                <Box sx={{
                                                    background: "#1a2537",
                                                    borderRadius: '15px',
                                                    padding: '30px',
                                                    border: "1px solid #D9D9D90D",
                                                }}>
                                                    <Box
                                                        sx={{

                                                            border: "1px dashed #00BCD4",
                                                            borderRadius: "8px",
                                                            height: 160,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            cursor: "pointer",
                                                            backgroundColor: "rgba(0, 188, 212, 0.05)",
                                                            "&:hover": {
                                                                backgroundColor: "rgba(0, 188, 212, 0.1)",
                                                            },
                                                            mb: 2
                                                        }}
                                                        onClick={() => document.getElementById("logo-upload").click()}
                                                    >
                                                        <input
                                                            id="logo-upload"
                                                            type="file"
                                                            accept="image/*"
                                                            style={{ display: "none" }}
                                                            // {...register1("logo", {
                                                            //     required: "logo is required",
                                                            // })}
                                                            onChange={handleImageUpload}
                                                        />
                                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                            {loader ?
                                                                <img
                                                                    src={Images.loader}
                                                                    alt="Loading..."
                                                                    style={{
                                                                        width: "120px",
                                                                        height: "120px",
                                                                        objectFit: "contain",
                                                                    }}
                                                                /> : <Typography
                                                                    variant="body2"
                                                                    sx={{ color: "#00BCD4", textAlign: "center", textDecoration: 'underline', wordBreak: 'break-all' }}
                                                                >
                                                                    {logo ? logo[0]?.split("/").pop() : "Drag & Drop Logo Here"}
                                                                </Typography>}
                                                        </Box>
                                                    </Box>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} md={6}>
                                                            <InputField2
                                                                label="Brand Name"
                                                                placeholder="Enter Business Brand Name"
                                                                error={errors1?.brandName?.message}
                                                                register={register1("brandName", {
                                                                    required: "Please enter brandName.",
                                                                })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <InputField2
                                                                label="Contact Person Name"
                                                                placeholder="Enter Contact Person Name"
                                                                error={errors1?.contactPersonName?.message}
                                                                register={register1("contactPersonName", {
                                                                    required: "Contact person name is required",
                                                                })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <InputField2
                                                                label="Email Address"
                                                                placeholder="Enter Email Address"
                                                                type="email"
                                                                disabled={true}
                                                                error={errors1?.email?.message}
                                                                register={register1("email", {
                                                                    required: "Email is required",
                                                                    pattern: {
                                                                        value: /^\S+@\S+$/i,
                                                                        message: "Invalid email address",
                                                                    },
                                                                })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <InputField2
                                                                label="Phone Number"
                                                                placeholder="Enter Phone Number"
                                                                error={errors1?.phoneNumber?.message}
                                                                register={register1("phoneNumber", {
                                                                    required: "Phone number is required",
                                                                })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <InputField2
                                                                label="Website URL (optional)"
                                                                placeholder="Enter Website URL"
                                                                error={errors1?.website?.message}
                                                                register={register1("website", {
                                                                    required: false,
                                                                })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} mb={0}>
                                                            <label style={{ color: "#a3abb2", fontWeight: 600 }}>
                                                                Contact Address
                                                            </label>
                                                        </Grid>
                                                        <Grid item xs={12} sx={{ pt: "5px !important" }}>
                                                            <InputField2
                                                                placeholder="Address 1"
                                                                error={errors1?.address1?.message}
                                                                register={register1("address1", {
                                                                    required: "Address is required",
                                                                })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sx={{ pt: "0px !important" }}>
                                                            <InputField2 placeholder="Address 2" />
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <SelectField
                                                                size="small"
                                                                label={"Select State"}
                                                                options={states}
                                                                selected={selectedState}
                                                                error={errors1?.singleState?.message}
                                                                onSelect={(value) => {
                                                                    console.log(value, 'value');

                                                                    setSelectedState(value)
                                                                    setValue1('singleState', value)
                                                                    getCities(value?.name)
                                                                }}
                                                                register={register1("singleState", {
                                                                    required: watch1('singleState') ? false : "Please select state.",
                                                                })}

                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <SelectField
                                                                size="small"
                                                                label={"Select City"}
                                                                multiple
                                                                options={cities}
                                                                selected={selectedCity}
                                                                error={errors1?.city?.message}
                                                                onSelect={(value) => {

                                                                    setSelectedCity(value)
                                                                    setValue1('city', value)
                                                                }}

                                                                register={register1("city", {
                                                                    required: watch1('city') ? false : "Please select city.",
                                                                })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <InputField2
                                                                label="Zip Code"
                                                                placeholder="Enter Zip Code"
                                                                error={errors1?.zipCode?.message}
                                                                register={register1("zipCode", {
                                                                    required: "Zip code is required",
                                                                })}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>

                                                    <Button
                                                        type="submit"
                                                        variant="contained"

                                                        sx={{
                                                            background: "#00BCD4",
                                                            color: "#101A33",
                                                            borderRadius: 4,
                                                            textTransform: "none",
                                                            fontWeight: 700,
                                                            fontSize: {
                                                                xs: "13px", // mobile
                                                                sm: "14px", // tablets
                                                                md: "15px", // laptops
                                                                lg: "16px", // large screens
                                                            },
                                                            px: {
                                                                xs: 2,  // padding-x small on mobile
                                                                sm: 3,
                                                                md: 4,
                                                                lg: 5,  // more padding on larger screens
                                                            },
                                                            py: {
                                                                xs: 1,  // padding-y small on mobile
                                                                sm: 1.2,
                                                                md: 1.5,
                                                            },
                                                            "&:hover": {
                                                                background: "#00ACC1",
                                                            },
                                                        }}

                                                    >
                                                        Save & Continue
                                                    </Button>
                                                </Box>

                                            </form>
                                        </Box>

                                    )}

                                    {activeStep === 1 && (
                                        <form onSubmit={handleSubmit2(onSubmit2)} >
                                            <Box sx={{
                                                background: "#1a2537",
                                                borderRadius: '15px',
                                                padding: '30px',
                                                border: "1px solid #D9D9D90D",
                                            }}>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6}>
                                                        <MultiSelectField
                                                            label="Select States"
                                                            options={states}
                                                            error={errors2?.state?.message}
                                                            value={selectedStates}
                                                            onSelect={(value) => {
                                                                setSelectedStates(value)
                                                                getCities2(value)
                                                            }
                                                            }
                                                            register={register2("state", {
                                                                required: selectedStates.length > 0 ? false : "Please select state.",
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <MultiSelectField
                                                            label="Select Cities"
                                                            options={cities2}
                                                            value={selectedCities}
                                                            onSelect={setSelectedCities}
                                                            error={errors2?.cities?.message}
                                                            register={register2("cities", {
                                                                required: selectedCities.length > 0 ? false : "Please select cities.",
                                                            })}
                                                        />
                                                    </Grid>

                                                </Grid>
                                            </Box>

                                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        color: "#0BD1D1",
                                                        border: " 2px solid #00BCD4",
                                                        px: 5,
                                                        py: 1.5,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        borderRadius: 4,
                                                        textTransform: "none",

                                                        fontWeight: 600,
                                                        "&:hover": { border: " 2px solid #00BCD4" },
                                                        mr: 2,

                                                    }}
                                                    onClick={() => setActiveStep(0)}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"

                                                    sx={{
                                                        background: "#00BCD4",
                                                        color: "#101A33",
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontWeight: 700,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        px: {
                                                            xs: 2,  // padding-x small on mobile
                                                            sm: 3,
                                                            md: 4,
                                                            lg: 5,  // more padding on larger screens
                                                        },
                                                        py: {
                                                            xs: 1,  // padding-y small on mobile
                                                            sm: 1.2,
                                                            md: 1.5,
                                                        },
                                                        "&:hover": {
                                                            background: "#00ACC1",
                                                        },
                                                    }}

                                                >
                                                    Save & Continue
                                                </Button>
                                            </Box>
                                        </form>
                                    )}
                                    {console.log(errors3, 'errors3')}
                                    {activeStep === 2 && (
                                        <form onSubmit={handleSubmit3(onSubmit3)} >
                                            <Box sx={{
                                                background: "#1a2537",
                                                borderRadius: '15px',
                                                padding: '30px',
                                                border: "1px solid #D9D9D90D",
                                            }}>
                                                <Grid container spacing={3}>
                                                    {/* Product Types Offered (Dropdown) */}
                                                    <Grid item xs={12} md={12}>
                                                        <SelectField
                                                            size="small"

                                                            label={"Select Product Type"}

                                                            options={[
                                                                { id: "T-shirts", name: "T-shirts" },
                                                                { id: "Hoodies", name: "Hoodies" },
                                                                { id: "Sleeveless", name: "Sleeveless" },
                                                            ]}
                                                            selected={selectedProductType}

                                                            onSelect={(value) => {

                                                                setSelectedProductType(value)
                                                                setValue3('productTypeSingle', value)
                                                            }}
                                                            error={errors3?.productTypeSingle?.message}
                                                            register={register3("productTypeSingle", {
                                                                required: "Product type is required",
                                                            })}
                                                        />
                                                    </Grid>

                                                    {/* Printing Methods */}


                                                    <Grid item xs={12} md={12}>
                                                        <Typography sx={{ color: "#a3abb2", fontWeight: 600, mb: 1 }}>
                                                            Printing Methods
                                                        </Typography>

                                                        <Controller
                                                            name="printingMethods"
                                                            control={control3}
                                                            rules={{ required: "Select at least one method" }}
                                                            render={({ field }) => {
                                                                const { value = [], onChange } = field

                                                                const handleToggle = (method) => {
                                                                    if (value.includes(method)) {
                                                                        onChange(value.filter((m) => m !== method))
                                                                    } else {
                                                                        onChange([...value, method])
                                                                    }
                                                                }

                                                                return (
                                                                    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                                                        {["Screen", "DTG", "DTF", "Laser"].map((method) => {
                                                                            const checked = value.includes(method)
                                                                            return (
                                                                                <Box
                                                                                    key={method}
                                                                                    onClick={() => handleToggle(method)}
                                                                                    sx={{
                                                                                        flex: "1",
                                                                                        maxWidth: "140px",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "flex-start",
                                                                                        border: "1px solid #3A4A5C",
                                                                                        borderRadius: "8px",
                                                                                        height: '35px',
                                                                                        px: 1,
                                                                                        pr: 2,
                                                                                        py: 1.5,
                                                                                        color: checked ? "#fff" : "#E0E6ED",
                                                                                        fontWeight: 500,
                                                                                        cursor: "pointer",
                                                                                        backgroundColor: checked ? "#00BCD4" : "transparent",
                                                                                        "&:hover": { borderColor: "#5A6A7C" },
                                                                                    }}
                                                                                >
                                                                                    <FormControlLabel
                                                                                        control={
                                                                                            <Checkbox
                                                                                                checked={checked}
                                                                                                onChange={() => handleToggle(method)}
                                                                                                icon={<RadioButtonUncheckedIcon sx={{ color: "#E0E6ED" }} />}
                                                                                                checkedIcon={<CheckCircleIcon sx={{ color: "white" }} />}
                                                                                                sx={{
                                                                                                    "& .MuiSvgIcon-root": { fontSize: 28 }, // circle size
                                                                                                }}
                                                                                            />
                                                                                        }
                                                                                        label={method}
                                                                                        sx={{
                                                                                            margin: 0,
                                                                                            "& .MuiFormControlLabel-label": {
                                                                                                fontSize: "14px",
                                                                                                fontWeight: 500,
                                                                                                color: checked ? "#fff" : "#E0E6ED",
                                                                                            },
                                                                                        }}
                                                                                    />
                                                                                </Box>
                                                                            )
                                                                        })}
                                                                    </Box>
                                                                )
                                                            }}
                                                        />

                                                        {errors3?.printingMethods && (
                                                            <Typography variant="caption" color="error">
                                                                {errors3.printingMethods.message}
                                                            </Typography>
                                                        )}
                                                    </Grid>




                                                    {/* Half Tone Printing (Radio Buttons) */}
                                                    <Grid item xs={12} md={6}>
                                                        <Box>
                                                            <Typography sx={{ mb: 0, color: "#a3abb2", fontWeight: 600 }}>
                                                                Do you provide Half Tone Printing?
                                                            </Typography>

                                                            <RadioGroup
                                                                row
                                                                value={halfTone}
                                                                onChange={(e) => setHalfTone(e.target.value)}
                                                            >
                                                                <FormControlLabel
                                                                    value="Yes"
                                                                    sx={{ color: "white" }}
                                                                    control={
                                                                        <Radio
                                                                            sx={{ color: "white" }}
                                                                            icon={
                                                                                <span
                                                                                    style={{
                                                                                        borderRadius: "50%",
                                                                                        width: 15,
                                                                                        height: 15,
                                                                                        border: "6px solid white",
                                                                                        backgroundColor: "white",
                                                                                        display: "inline-block",
                                                                                    }}
                                                                                />
                                                                            }
                                                                            checkedIcon={
                                                                                <span
                                                                                    style={{
                                                                                        borderRadius: "50%",
                                                                                        width: 15,
                                                                                        height: 15,
                                                                                        border: "6px solid white",
                                                                                        backgroundColor: "#00BCD4",
                                                                                        display: "inline-block",
                                                                                    }}
                                                                                />
                                                                            }
                                                                        />
                                                                    }
                                                                    label="Yes"
                                                                />
                                                                <FormControlLabel
                                                                    value="No"
                                                                    sx={{ color: "white" }}
                                                                    control={
                                                                        <Radio
                                                                            icon={
                                                                                <span
                                                                                    style={{
                                                                                        borderRadius: "50%",
                                                                                        width: 15,
                                                                                        height: 15,
                                                                                        border: "6px solid white",
                                                                                        backgroundColor: "white",
                                                                                        display: "inline-block",
                                                                                    }}
                                                                                />
                                                                            }
                                                                            checkedIcon={
                                                                                <span
                                                                                    style={{
                                                                                        borderRadius: "50%",
                                                                                        width: 15,
                                                                                        height: 15,
                                                                                        border: "6px solid white",
                                                                                        backgroundColor: "#00BCD4",
                                                                                        display: "inline-block",
                                                                                    }}
                                                                                />
                                                                            }
                                                                        />
                                                                    }
                                                                    label="No"
                                                                />
                                                            </RadioGroup>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            {/* Submit Button */}
                                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        color: "#0BD1D1",
                                                        border: " 2px solid #00BCD4",
                                                        px: 5,
                                                        py: 1.5,
                                                        borderRadius: 4,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        textTransform: "none",

                                                        fontWeight: 600,
                                                        "&:hover": { border: " 2px solid #00BCD4" },
                                                        mr: 2,

                                                    }}
                                                    onClick={() => setActiveStep(1)}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"

                                                    sx={{
                                                        background: "#00BCD4",
                                                        color: "#101A33",
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontWeight: 700,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        px: {
                                                            xs: 2,  // padding-x small on mobile
                                                            sm: 3,
                                                            md: 4,
                                                            lg: 5,  // more padding on larger screens
                                                        },
                                                        py: {
                                                            xs: 1,  // padding-y small on mobile
                                                            sm: 1.2,
                                                            md: 1.5,
                                                        },
                                                        "&:hover": {
                                                            background: "#00ACC1",
                                                        },
                                                    }}

                                                >
                                                    Save & Continue
                                                </Button>
                                            </Box>
                                        </form>

                                    )}

                                    {activeStep === 3 && (
                                        <form onSubmit={handleSubmit4((data) =>
                                            editState
                                                ? onSubmit4Update(data, selectedIndex) // ✅ pass index when updating
                                                : onSubmit4(data)                  // ✅ normal add
                                        )} >
                                            <Box sx={{
                                                background: "#1a2537",
                                                borderRadius: '15px',
                                                padding: '30px',
                                                border: "1px solid #D9D9D90D",
                                            }}>
                                                <Grid container spacing={3}>
                                                    {/* Dropdowns */}
                                                    <Grid item xs={12} md={6}>
                                                        <SelectField
                                                            label="Product Type"
                                                            options={[
                                                                { id: "T-shirts", name: "T-shirts", image: Images.tshirt },
                                                                { id: "Hoodies", name: "Hoodies", image: Images.hoodie },
                                                                { id: "Sleeveless", name: "Sleeveless", image: Images.sleevless },
                                                            ]}
                                                            selected={selectedProductType2}
                                                            onSelect={(value) => setSelectedProductType2(value)}
                                                            error={errors4?.productType?.message}
                                                            register4={register4("productType", {
                                                                required: selectedProductType2 ? false : "Product type is required",
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <MultiSelectField
                                                            label="Standard Fabric"
                                                            options={[
                                                                { id: "Cotton", name: "Cotton" },
                                                                { id: "Polyester", name: "Polyester" },
                                                                { id: "Cotton/Poly Blend", name: "Cotton/Poly Blend" },
                                                                { id: "Dry Fit", name: "Dry Fit" },
                                                                { id: "Fleece", name: "Fleece" },
                                                                { id: "Jersey Knit", name: "Jersey Knit" }
                                                            ]
                                                            }
                                                            value={selectedFabrics}
                                                            onSelect={setSelectedFabrics}
                                                            error={errors4?.fabric?.message}
                                                            register={register4("fabric", {
                                                                required: selectedFabrics?.length > 0 ? false : "Fabric is required",
                                                            })}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <MultiSelectField
                                                            label="Premium Fabric"
                                                            options={[
                                                                { id: "Ring-Spun Cotton", name: "Ring-Spun Cotton" },
                                                                { id: "Combed Cotton", name: "Combed Cotton" },
                                                                { id: "Tri-Blend", name: "Tri-Blend (Cotton/Poly/Rayon)" },
                                                                { id: "Organic Cotton", name: "Organic Cotton" },
                                                                { id: "Supima Cotton", name: "Supima Cotton" },
                                                                { id: "Pima Cotton", name: "Pima Cotton" },
                                                                { id: "Bamboo", name: "Bamboo" },
                                                                { id: "Modal", name: "Modal" },
                                                                { id: "Lycra/Spandex Blend", name: "Lycra/Spandex Blend" },
                                                            ]}
                                                            value={selectedFabrics2}
                                                            onSelect={setSelectedFabrics2}
                                                            error={errors4?.pfabrics?.message}
                                                            register={register4("pfabrics", {
                                                                validate: (value, formValues) => {
                                                                    const {
                                                                        premiumOneSide,
                                                                        premiumDoubleSide,
                                                                        premiumAdditional,
                                                                        premiumDescription,
                                                                    } = formValues;

                                                                    const anyFilled =
                                                                        !!premiumOneSide ||
                                                                        !!premiumDoubleSide ||
                                                                        !!premiumAdditional ||
                                                                        !!premiumDescription;

                                                                    // ✅ Require fabric if any of the above fields are filled
                                                                    if (anyFilled) {
                                                                        if (!selectedFabrics2 || selectedFabrics2.length === 0) {
                                                                            return "Premium Fabric is required";
                                                                        }
                                                                    }
                                                                    return true;
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <MultiSelectField
                                                            label="Adult Size"
                                                            options={[
                                                                { id: "XS", name: "XS" },
                                                                { id: "S", name: "S" },
                                                                { id: "M", name: "M" },
                                                                { id: "L", name: "L" },
                                                                { id: "XL", name: "XL" },
                                                                { id: "XXL", name: "XXL" },
                                                                { id: "XXXL", name: "XXXL" },
                                                            ]}
                                                            value={selectedAdultSizes}
                                                            onSelect={setSelectedAdultSizes}
                                                            error={errors4?.adultSize?.message}
                                                            register={register4("adultSize", {
                                                                required: selectedAdultSizes?.length > 0 ? false : "Adult size is required",
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <MultiSelectField
                                                            label="Youth Size"
                                                            options={[
                                                                { id: "YS (Youth Small)", name: "YS (Youth Small)" },
                                                                { id: "YM (Youth Medium)", name: "YM (Youth Medium)" },
                                                                { id: "YL (Youth Large)", name: "YL (Youth Large)" },
                                                                { id: "YXL (Youth XL)", name: "YXL (Youth XL)" },
                                                            ]}
                                                            value={selectedYouthSizes}
                                                            onSelect={setSelectedYouthSizes}
                                                            error={errors4?.youthSize?.message}
                                                            register={register4("youthSize", {
                                                                required: false,
                                                            })}
                                                        />
                                                    </Grid>

                                                    {/* Color Picker */}
                                                    <Grid item xs={12} md={6}>

                                                        <label style={{ color: "#a3abb2", fontWeight: 600, fontFamily: "Maven Pro, sans-serif", marginBottom: 2 }}>Color</label>

                                                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                                            {colors.map((color) => {
                                                                const isSelected = selectedColors.includes(color?.name);
                                                                return (
                                                                    <Box
                                                                        key={color.name}
                                                                        sx={{
                                                                            width: 28,
                                                                            height: 28,
                                                                            borderRadius: "50%",
                                                                            backgroundColor: color?.name,
                                                                            border: isSelected ? "2px solid #3b82f6" : "1px solid #ccc",
                                                                            cursor: "pointer",
                                                                            boxShadow: isSelected ? "0 0 6px #3b82f6" : "none",
                                                                        }}
                                                                        onClick={() => toggleColor(color?.name)}
                                                                    />
                                                                );
                                                            })}
                                                        </Box>

                                                        {/* RHF Validation */}
                                                        <input
                                                            type="hidden"
                                                            value={selectedColors}
                                                            {...register4("color", {
                                                                validate: (value) =>
                                                                    selectedColors.length > 0 || "At least one color is required",
                                                            })}
                                                        />

                                                        {errors4?.color && (
                                                            <Typography variant="caption" color="error">
                                                                {errors4.color.message}
                                                            </Typography>
                                                        )}
                                                    </Grid>

                                                    {/* Standard Pricing */}
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{ color: "white", mb: 0, fontFamily: "Maven Pro, sans-serif", fontWeight: 700 }}
                                                        >
                                                            Standard Pricing
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <InputField2
                                                            label="One Side Print"
                                                            type="number"
                                                            placeholder="One Side Print"
                                                            startIcon={currencyType2[vendorData?.country]?.code}
                                                            error={errors4?.standardOneSide?.message}
                                                            register={register4("standardOneSide", {
                                                                required: "One side print price is required",
                                                                validate: (value) =>
                                                                    Number(value) > 0 || "Price must be greater than 0",
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <InputField2
                                                            label="Double Side Print"
                                                            type="number"
                                                            placeholder="Double Side Print"
                                                            startIcon={currencyType2[vendorData?.country]?.code}
                                                            error={errors4?.standardDoubleSide?.message}
                                                            register={register4("standardDoubleSide", {
                                                                required: "Double side print price is required",
                                                                validate: (value) =>
                                                                    Number(value) > 0 || "Price must be greater than 0",
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <InputField2
                                                            label="Additional Image"
                                                            type="number"
                                                            placeholder="Additional Image"
                                                            startIcon={currencyType2[vendorData?.country]?.code}
                                                            error={errors4?.standardAdditional?.message}
                                                            register={register4("standardAdditional", {
                                                                required: "Additional image print price is required",
                                                                // validate: (value) =>
                                                                //     Number(value) > 0 || "Price must be greater than 0",
                                                            })}
                                                        />
                                                    </Grid>


                                                    <Grid item xs={12}>
                                                        <InputField2
                                                            label="Description"
                                                            placeholder="Type Description"
                                                            multiline
                                                            rows={2}
                                                            error={errors4?.standardDescription?.message}
                                                            register={register4("standardDescription", {
                                                                required: "Standard description is required",
                                                            })}
                                                        />
                                                    </Grid>

                                                    {/* Premium Pricing */}
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                color: "white",
                                                                mt: 3,
                                                                mb: 0,
                                                                fontFamily: "Maven Pro, sans-serif",
                                                                fontWeight: 700
                                                            }}
                                                        >
                                                            Premium Pricing
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <InputField2
                                                            label="One Side Print"
                                                            type="number"
                                                            placeholder="One Side Print"
                                                            startIcon={currencyType2[vendorData?.country]?.code}
                                                            error={errors4?.premiumOneSide?.message}
                                                            register={register4("premiumOneSide", {
                                                                validate: (value, formValues) => {
                                                                    const { premiumDoubleSide, premiumAdditional, premiumDescription } = formValues;
                                                                    const anyFilled =
                                                                        !!value || !!premiumDoubleSide || !!premiumAdditional || !!premiumDescription;

                                                                    // ✅ also check if selectedFabrics2 has items
                                                                    const requireAll = anyFilled || selectedFabrics2.length > 0;

                                                                    if (requireAll) {
                                                                        if (!value) return "One Side Print is required";
                                                                        if (Number(value) === 0) return "Price must be greater than 0";
                                                                    }
                                                                    return true;
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <InputField2
                                                            label="Double Side Print"
                                                            type="number"
                                                            placeholder="Double Side Print"
                                                            startIcon={currencyType2[vendorData?.country]?.code}
                                                            error={errors4?.premiumDoubleSide?.message}
                                                            register={register4("premiumDoubleSide", {
                                                                validate: (value, formValues) => {
                                                                    const { premiumOneSide, premiumAdditional, premiumDescription } = formValues;
                                                                    const anyFilled =
                                                                        !!premiumOneSide || !!value || !!premiumAdditional || !!premiumDescription;

                                                                    const requireAll = anyFilled || selectedFabrics2.length > 0;

                                                                    if (requireAll) {
                                                                        if (!value) return "Double Side Print is required";
                                                                        if (Number(value) === 0) return "Price must be greater than 0";
                                                                    }
                                                                    return true;
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <InputField2
                                                            label="Additional Image"
                                                            type="number"
                                                            placeholder="Additional Image"
                                                            startIcon={currencyType2[vendorData?.country]?.code}
                                                            error={errors4?.premiumAdditional?.message}
                                                            register={register4("premiumAdditional", {
                                                                validate: (value, formValues) => {
                                                                    const { premiumOneSide, premiumDoubleSide, premiumDescription } = formValues;
                                                                    const anyFilled =
                                                                        !!premiumOneSide || !!premiumDoubleSide || !!value || !!premiumDescription;

                                                                    const requireAll = anyFilled || selectedFabrics2.length > 0;

                                                                    if (requireAll) {
                                                                        if (!value) return "Additional Image Print is required";
                                                                    }
                                                                    return true;
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <InputField2
                                                            label="Description"
                                                            placeholder="Type Description"
                                                            multiline
                                                            rows={2}
                                                            error={errors4?.premiumDescription?.message}
                                                            register={register4("premiumDescription", {
                                                                validate: (value, formValues) => {
                                                                    const { premiumOneSide, premiumDoubleSide, premiumAdditional } = formValues;
                                                                    const anyFilled =
                                                                        !!premiumOneSide || !!premiumDoubleSide || !!premiumAdditional || !!value;

                                                                    const requireAll = anyFilled || selectedFabrics2.length > 0;

                                                                    if (requireAll) {
                                                                        if (!value) return "Description is required";
                                                                    }
                                                                    return true;
                                                                },
                                                            })}
                                                        />
                                                    </Grid>



                                                    {/* Upload Sample Images */}
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: "#a3abb2",
                                                                mb: 1,
                                                                fontFamily: "Maven Pro, sans-serif",
                                                                fontWeight: 700,
                                                            }}
                                                        >
                                                            Upload Product Sample Images{" "}
                                                        </Typography>

                                                        {/* Upload Box */}
                                                        <Box
                                                            sx={{
                                                                border: "1px dashed rgba(255,255,255,0.3)",
                                                                borderRadius: 2,
                                                                p: 4,
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                textAlign: "center",
                                                                textDecoration: "underline",
                                                                color: "#0BD1D1",
                                                                cursor: "pointer",
                                                                height: "100px",
                                                            }}
                                                            onClick={() => document.getElementById("sample-upload2").click()}
                                                        >
                                                            {loader ? (
                                                                <img
                                                                    src={Images.loader}
                                                                    alt="Loading..."
                                                                    style={{
                                                                        width: "120px",
                                                                        height: "120px",
                                                                        objectFit: "contain",
                                                                    }}
                                                                />
                                                            ) : (
                                                                "Drag & Drop Image Here"
                                                            )}
                                                            <input
                                                                id="sample-upload2"
                                                                type="file"
                                                                multiple
                                                                hidden
                                                                {...register4("sampleImages", {
                                                                    required: uploadedImages4?.length > 0 ? false : "Please upload at least one sample image",
                                                                    validate: (files) =>
                                                                        uploadedImages4?.length > 0 || "Please upload at least one sample image",
                                                                })}
                                                                onChange={(event) => {
                                                                    handleImageUpload4(event); // Handle file upload
                                                                    setValue4("sampleImages", event.target.files); // RHF
                                                                }}
                                                            />
                                                        </Box>

                                                        {/* Error Message */}
                                                        {errors4?.sampleImages && (
                                                            <Typography
                                                                variant="caption"
                                                                sx={{
                                                                    color: "red",
                                                                    mt: 1,
                                                                    fontFamily: "Maven Pro, sans-serif",
                                                                }}
                                                            >
                                                                {errors4.sampleImages.message}
                                                            </Typography>
                                                        )}

                                                        {/* Preview Images */}
                                                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 2 }}>
                                                            {uploadedImages4.map((img, index) => (
                                                                <Box
                                                                    key={index}
                                                                    sx={{
                                                                        position: "relative",
                                                                        width: 80,
                                                                        height: 80,
                                                                        borderRadius: 2,
                                                                        overflow: "hidden",
                                                                        border: "1px solid rgba(255,255,255,0.2)",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={img}
                                                                        alt={`uploaded-${index}`}
                                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                    />

                                                                    {/* Remove Icon */}
                                                                    <IconButton
                                                                        size="small"
                                                                        sx={{
                                                                            position: "absolute",
                                                                            top: 2,
                                                                            right: 2,
                                                                            background: "rgba(0,0,0,0.6)",
                                                                            color: "white",
                                                                            "&:hover": { background: "rgba(0,0,0,0.8)" },
                                                                        }}
                                                                        onClick={() =>
                                                                            setUploadedImages4((prev) => prev.filter((_, i) => i !== index))
                                                                        }
                                                                    >
                                                                        <CloseIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Grid>


                                                    {/* Upload Size Chart */}
                                                    <Grid item xs={12} md={6} sx={{ display: "flex", gap: 2, alignItems: "flex-start", flexDirection: 'column' }}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: "#a3abb2",
                                                                mb: 1,
                                                                fontWeight: 700,
                                                                fontFamily: "Maven Pro, sans-serif",
                                                                fontSize: {
                                                                    xs: "12px", // small screens (mobile)
                                                                    sm: "13px", // tablets
                                                                    md: "14px", // small laptops
                                                                    lg: "15px", // large desktops
                                                                    xl: "16px", // extra large screens
                                                                },
                                                            }}
                                                        >
                                                            Upload Size Chart{" "}
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    color: "#00BCD4",
                                                                    cursor: "pointer",
                                                                    ml: 1,
                                                                    fontSize: {
                                                                        xs: "12px",
                                                                        sm: "13px",
                                                                        md: "14px",
                                                                        lg: "15px",
                                                                        xl: "16px",
                                                                    },
                                                                }}
                                                                onClick={() => downloadTemplate()}
                                                            >
                                                                (Download Template)
                                                            </Typography>

                                                            {/* Eye Icon */}
                                                            {uploadedData?.length > 0 && (
                                                                <IconButton size="small" onClick={handleOpen}>
                                                                    <VisibilityIcon sx={{ color: 'white' }} fontSize="small" />
                                                                </IconButton>
                                                            )}
                                                        </Typography>

                                                        {/* Upload Box */}
                                                        <Box
                                                            sx={{
                                                                border: "1px dashed white",
                                                                borderRadius: 3,
                                                                p: 4,
                                                                textAlign: "center",
                                                                color: "white",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                backgroundColor: "#3b4d5c",
                                                                minWidth: 50,
                                                                minHeight: 30,
                                                            }}
                                                            onClick={() => document.getElementById("csv-upload").click()}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    width: 24,
                                                                    height: 24,
                                                                    borderRadius: "50%",
                                                                    border: "2px solid white",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    mb: 0,
                                                                }}
                                                            >
                                                                <AddIcon sx={{ color: "white", fontSize: "18px" }} />
                                                            </Box>

                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    fontWeight: 500,
                                                                    fontSize: "14px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 1,
                                                                }}
                                                            >
                                                                {selectedCsv ? selectedCsv?.name : "Upload Csv"}
                                                            </Typography>

                                                            {/* Hidden Input */}
                                                            <input
                                                                id="csv-upload"
                                                                type="file"
                                                                accept=".csv"
                                                                multiple
                                                                hidden
                                                                {...register4("csv", {
                                                                    required: uploadedData?.length ? false : "CSV file is required",
                                                                })}
                                                                onChange={handleFileUpload}
                                                            />
                                                        </Box>

                                                        {/* Error Message */}
                                                        {errors4?.csv && (
                                                            <Typography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                                                                {errors4.csv.message}
                                                            </Typography>
                                                        )}



                                                    </Grid>
                                                </Grid>


                                            </Box>

                                            {/* Submit Button */}
                                            {/* <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        color: "#0BD1D1",
                                                        border: " 2px solid #00BCD4",
                                                        px: 5,
                                                        py: 1.5,
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontSize: "16px",
                                                        fontWeight: 600,
                                                        "&:hover": { border: " 2px solid #00BCD4" },
                                                        mr: 2,

                                                    }}
                                                    onClick={() => setActiveStep(2)}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"

                                                    sx={{
                                                        background: "#00BCD4",
                                                        color: "white",
                                                        px: 4,
                                                        py: 1.5,
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        color: '#101A33',
                                                        fontSize: "16px",
                                                        fontWeight: 700,
                                                        "&:hover": {
                                                            background: "#00ACC1",
                                                        },
                                                    }}

                                                >
                                                    Save & Continue
                                                </Button>
                                            </Box> */}


                                            {activeStep === 3 && <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>

                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    // disabled={products?.length == 0}
                                                    sx={{
                                                        background: "#00BCD4",
                                                        color: "white",
                                                        px: 4,
                                                        py: 1.5,
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        color: '#101A33',
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        fontWeight: 700,
                                                        "&:hover": {
                                                            background: "#00ACC1",
                                                        },
                                                    }}
                                                // onClick={() => setActiveStep(4)}
                                                >
                                                    {editState ? 'Update' : "Add "}
                                                </Button>
                                            </Box>}
                                        </form>


                                    )}
                                    {console.log(products)
                                    }
                                    {activeStep === 3 && products?.map((product, index) => (
                                        <Grid
                                            key={index}
                                            container
                                            mt={5}
                                            xs={12}
                                            p={2}
                                            sx={{
                                                background: "#1a2537",
                                                borderRadius: "15px",
                                                border: "1px solid #D9D9D90D",
                                                color: "white",
                                                mb: 3
                                            }}
                                        >
                                            <Grid container spacing={2}>
                                                {/* Left Side - Main Image + Thumbnails */}
                                                <Grid item xs={12} md={5}>
                                                    <Box sx={{ borderRadius: 3, overflow: "hidden", mb: 2, bgcolor: "#fff" }}>
                                                        <img
                                                            src={product.sample_images?.[0] ? product.sample_images?.[0] : 'https://cdn.vectorstock.com/i/preview-1x/94/00/default-placeholder-fitness-trainer-in-a-t-shirt-vector-21189400.jpg'}
                                                            alt="main product"
                                                            style={{ width: "100%", display: "block" }}
                                                        />
                                                    </Box>

                                                    <Box sx={{ display: "flex", gap: 1 }}>
                                                        {product?.sample_images?.map((pic, i) => (
                                                            <Box
                                                                key={i}
                                                                sx={{
                                                                    width: 60,
                                                                    height: 60,
                                                                    borderRadius: 2,
                                                                    overflow: "hidden",
                                                                    cursor: "pointer",
                                                                    border: "2px solid rgba(255,255,255,0.2)",
                                                                }}
                                                            >
                                                                <img
                                                                    src={pic}
                                                                    alt={`thumb-${i}`}
                                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                />
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                </Grid>

                                                {/* Right Side */}
                                                <Grid item xs={12} md={7}>
                                                    {/* Title */}
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <Box sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            mb: 2,
                                                            gap: 2
                                                        }}
                                                        >


                                                            <img src={Images.shirtIcon} alt="Edit" style={{ width: 50, height: 50 }} />


                                                            <Typography variant="h4" sx={{ fontWeight: 600, mt: 2 }}>
                                                                {product.type || "Product"}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    gap: 1,
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <Box
                                                                    component="img"
                                                                    src={Images.editLite}
                                                                    alt="Edit"
                                                                    onClick={() => {
                                                                        setSelectedIndex(index);
                                                                        console.log(product, 'product');
                                                                        setSelectedProductType2({ id: product?.type, name: product?.type });
                                                                        setSelectedFabrics(
                                                                            product?.fabrics?.map((item) => ({ key: item, name: item })) || []
                                                                        );
                                                                        setSelectedFabrics2(
                                                                            product?.premium_fabrics?.map((item) => ({ key: item, name: item })) || []
                                                                        );
                                                                        setSelectedAdultSizes(
                                                                            product?.adult_sizes?.map((item) => ({ key: item, name: item })) || []
                                                                        );
                                                                        setSelectedYouthSizes(
                                                                            product?.youth_sizes?.map((item) => ({ key: item, name: item })) || []
                                                                        );
                                                                        setSelectedColors(product?.colors);
                                                                        setValue4('standardOneSide', product?.standardOneSide);
                                                                        setValue4('standardDoubleSide', product?.standardDoubleSide);
                                                                        setValue4('standardAdditional', product?.standardAdditional);
                                                                        setValue4('standardDescription', product?.standardDescription);
                                                                        setValue4('premiumOneSide', product?.premiumOneSide);
                                                                        setValue4('premiumDoubleSide', product?.premiumDoubleSide);
                                                                        setValue4('premiumAdditional', product?.premiumAdditional);
                                                                        setValue4('premiumDescription', product?.premiumDescription);
                                                                        setUploadedImages4(product?.sample_images);
                                                                        console.log(product?.size_chart);
                                                                        setUploadedData(product?.size_chart);
                                                                        setEditState(true);
                                                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                    }}
                                                                    sx={{
                                                                        width: {
                                                                            xs: 25, // small on mobile
                                                                            sm: 25, // medium on tablets
                                                                            md: 30, // default desktop
                                                                            lg: 35, // large screens
                                                                        },
                                                                        height: {
                                                                            xs: 25,
                                                                            sm: 25,
                                                                            md: 30,
                                                                            lg: 35,
                                                                        },
                                                                        transition: "transform 0.2s ease",
                                                                        "&:hover": {
                                                                            transform: "scale(1.1)",
                                                                        },
                                                                    }}
                                                                />
                                                            </Box>

                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    gap: 1,
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <Box
                                                                    component="img"
                                                                    src={Images.deletelite}
                                                                    alt="Delete"
                                                                    onClick={() => {
                                                                        // Remove selected product from array
                                                                        setProducts((prevProducts) => prevProducts.filter((_, i) => i !== index));

                                                                        // Optionally reset state if the deleted product was selected
                                                                        if (selectedIndex === index) {
                                                                            setSelectedIndex(null);
                                                                            setSelectedProductType2(null);
                                                                            setSelectedFabrics([]);
                                                                            setSelectedAdultSizes([]);
                                                                            setSelectedYouthSizes([]);
                                                                            setSelectedColors([]);
                                                                            setUploadedImages4([]);
                                                                            setEditState(false);
                                                                        }
                                                                    }}
                                                                    sx={{
                                                                        width: {
                                                                            xs: 25, // mobile
                                                                            sm: 25, // tablet
                                                                            md: 30, // desktop
                                                                            lg: 35, // large screens
                                                                        },
                                                                        height: {
                                                                            xs: 25,
                                                                            sm: 25,
                                                                            md: 30,
                                                                            lg: 35,
                                                                        },
                                                                        transition: "transform 0.2s ease",
                                                                        "&:hover": {
                                                                            transform: "scale(1.1)",
                                                                        },
                                                                    }}
                                                                />
                                                            </Box>

                                                        </Box>
                                                    </Box>

                                                    {/* Details */}
                                                    <Grid container sx={{ borderRadius: 2, overflow: "hidden", mb: 3 }}>
                                                        {/* Fabric */}
                                                        <Grid item xs={6} sx={{ borderRight: "1px solid rgba(255,255,255,0.2)", borderBottom: "1px solid rgba(255,255,255,0.2)", p: 2 }}>
                                                            <Typography variant="body2" sx={{ opacity: 0.7 }}>Standard Fabrics</Typography>
                                                            <Typography variant="body1" sx={{ fontWeight: 600, wordBreak: 'break-word' }}>
                                                                {product?.fabrics?.join(",")}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6} sx={{ borderBottom: "1px solid rgba(255,255,255,0.2)", p: 2 }}>
                                                            <Typography variant="body2" sx={{ opacity: 0.7 }}>Premium Fabrics</Typography>
                                                            <Typography variant="body1" sx={{ fontWeight: 600, wordBreak: 'break-word' }}>
                                                                {product?.premium_fabrics?.join(",")}
                                                            </Typography>
                                                        </Grid>
                                                        {/* Adult Size */}
                                                        <Grid item xs={6} sx={{ borderRight: "1px solid rgba(255,255,255,0.2)", p: 2 }}>
                                                            <Typography variant="body2" sx={{ opacity: 0.7 }}>Adult Size</Typography>
                                                            <Typography variant="body1" sx={{ fontWeight: 600, wordBreak: 'break-word' }}>
                                                                {product?.adult_sizes?.join(",")}
                                                            </Typography>
                                                        </Grid>

                                                        {/* Youth Size */}
                                                        <Grid item xs={6} sx={{ p: 2 }}>
                                                            <Typography variant="body2" sx={{ opacity: 0.7 }}>Youth Size</Typography>
                                                            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                                                {product?.youth_sizes?.join(",")}
                                                            </Typography>
                                                        </Grid>

                                                        {/* Colors */}
                                                        <Grid item xs={12} sx={{ p: 2, mt: 2 }}>
                                                            <Typography variant="body2" sx={{ opacity: 0.7 }}>Color Options</Typography>
                                                            <Box sx={{ display: "flex", gap: 1, mt: 0.5 }}>
                                                                {product?.colors?.map((c, i) => (
                                                                    <Box
                                                                        key={i}
                                                                        sx={{
                                                                            width: 18,
                                                                            height: 18,
                                                                            borderRadius: "50%",
                                                                            backgroundColor: c,
                                                                            border: "1px solid #fff",
                                                                        }}
                                                                    />
                                                                ))}
                                                            </Box>
                                                        </Grid>
                                                    </Grid>

                                                    {/* Standard Pricing */}
                                                    <Box sx={{ mt: 3 }}>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <Typography variant="body2" sx={{ fontWeight: 600, pb: 1 }}>
                                                                Standard T-shirt Prices
                                                            </Typography>
                                                            <hr style={{ flex: 1, border: "none", borderBottom: "1px solid rgba(255,255,255,0.2)" }} />
                                                        </Box>
                                                        <Grid container>
                                                            <Grid item xs={12} md={4} sx={{ borderRight: { md: "1px solid rgba(255,255,255,0.2)", xs: '' }, borderBottom: { xs: "1px solid rgba(255,255,255,0.2)", md: '' }, p: 2 }}>
                                                                <Typography variant="body2" sx={{ opacity: 0.7 }}>One Side Print</Typography>
                                                                <Typography variant="body1" sx={{ fontWeight: 600 }}>{currencyType2[vendorData?.country]?.code} {product.standardOneSide}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={4} sx={{ borderRight: { md: "1px solid rgba(255,255,255,0.2)", xs: '' }, p: 2, borderBottom: { xs: "1px solid rgba(255,255,255,0.2)", md: '' } }}>
                                                                <Typography variant="body2" sx={{ opacity: 0.7 }}>Double Side Print</Typography>
                                                                <Typography variant="body1" sx={{ fontWeight: 600 }}>{currencyType2[vendorData?.country]?.code} {product.standardDoubleSide}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={4} sx={{ p: 2, borderBottom: { xs: "1px solid rgba(255,255,255,0.2)", md: '' } }}>
                                                                <Typography variant="body2" sx={{ opacity: 0.7 }}>Additional Image</Typography>
                                                                <Typography variant="body1" sx={{ fontWeight: 600 }}>{currencyType2[vendorData?.country]?.code} {product.standardAdditional}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>

                                                    {/* Premium Pricing */}
                                                    {product.premiumOneSide && <Box sx={{ mt: 3 }}>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <Typography variant="body2" sx={{ fontWeight: 600, pb: 1 }}>
                                                                Premium T-shirt Prices
                                                            </Typography>
                                                            <hr style={{ flex: 1, border: "none", borderBottom: "1px solid rgba(255,255,255,0.2)" }} />
                                                        </Box>
                                                        <Grid container>
                                                            <Grid item xs={12} md={4} sx={{ borderRight: { md: "1px solid rgba(255,255,255,0.2)", xs: '' }, p: 2, borderBottom: { xs: "1px solid rgba(255,255,255,0.2)", md: '' } }}>
                                                                <Typography variant="body2" sx={{ opacity: 0.7 }}>One Side Print</Typography>
                                                                <Typography variant="body1" sx={{ fontWeight: 600 }}>{currencyType2[vendorData?.country]?.code} {product.premiumOneSide}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={4} sx={{ borderRight: { md: "1px solid rgba(255,255,255,0.2)", xs: '' }, p: 2, borderBottom: { xs: "1px solid rgba(255,255,255,0.2)", md: '' } }}>
                                                                <Typography variant="body2" sx={{ opacity: 0.7 }}>Double Side Print</Typography>
                                                                <Typography variant="body1" sx={{ fontWeight: 600 }}> {currencyType2[vendorData?.country]?.code} {product.premiumDoubleSide}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={4} sx={{ p: 2, borderBottom: { xs: "1px solid rgba(255,255,255,0.2)", md: '' } }}>
                                                                <Typography variant="body2" sx={{ opacity: 0.7 }}>Additional Image</Typography>
                                                                <Typography variant="body1" sx={{ fontWeight: 600 }}>{currencyType2[vendorData?.country]?.code} {product.premiumAdditional}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>}
                                                    <Box sx={{ mt: 3 }}> <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }} > Chart Table Size In Inches </Typography>
                                                        <Box sx={{ border: "1px solid rgba(255,255,255,0.3)", borderRadius: 2, overflow: "hidden", }} >
                                                            <table style={{ width: "100%", borderCollapse: "collapse", color: "white", }} >
                                                                <thead>
                                                                    <tr > <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Size</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Chest</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Length</th> <th style={{ padding: "10px", textAlign: "left", fontFamily: "Maven Pro, sans-serif" }}>Shoulder</th> </tr> </thead>

                                                                <tbody>
                                                                    {console.log(product?.size_chart, 'product?.size_chart')}
                                                                    {product?.size_chart?.length > 0 &&
                                                                        product?.size_chart?.map((row, i) => (
                                                                            <tr
                                                                                key={i}
                                                                                style={{ borderTop: "1px solid rgba(255,255,255,0.2)" }}
                                                                            >
                                                                                {/* Map over the values of each object */}
                                                                                {Object.values(row).map((col, j) => (
                                                                                    <td key={j} style={{ padding: "10px", fontSize: "14px" }}>
                                                                                        {col}
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        ))}
                                                                </tbody>
                                                            </table> </Box> </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ))}
                                    {activeStep === 3 && <Box sx={{ display: "flex", justifyContent: 'flex-end', mt: 4 }}>
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                color: "#0BD1D1",
                                                border: " 2px solid #00BCD4",
                                                px: 5,
                                                py: 1.5,
                                                borderRadius: 4,
                                                textTransform: "none",
                                                fontSize: {
                                                    xs: "13px", // mobile
                                                    sm: "14px", // tablets
                                                    md: "15px", // laptops
                                                    lg: "16px", // large screens
                                                },
                                                fontWeight: 600,
                                                "&:hover": { border: " 2px solid #00BCD4" },
                                                mr: 2,

                                            }}
                                            onClick={() => setActiveStep(2)}
                                        >
                                            Back
                                        </Button>
                                        <Button

                                            variant="contained"
                                            disabled={products.length == 0}
                                            sx={{
                                                background: "#00BCD4",
                                                color: "#101A33",
                                                borderRadius: 4,
                                                textTransform: "none",
                                                fontWeight: 700,
                                                fontSize: {
                                                    xs: "13px", // mobile
                                                    sm: "14px", // tablets
                                                    md: "15px", // laptops
                                                    lg: "16px", // large screens
                                                },
                                                px: {
                                                    xs: 2,  // padding-x small on mobile
                                                    sm: 3,
                                                    md: 4,
                                                    lg: 5,  // more padding on larger screens
                                                },
                                                py: {
                                                    xs: 1,  // padding-y small on mobile
                                                    sm: 1.2,
                                                    md: 1.5,
                                                },
                                                "&:hover": {
                                                    background: "#00ACC1",
                                                },
                                            }}
                                            onClick={() => addProductSubmit()}

                                        >
                                            Save & Continue
                                        </Button>
                                    </Box>}

                                    {activeStep === 4 && (
                                        <form onSubmit={handleSubmit5(onSubmit5)} >
                                            <Box sx={{
                                                background: "#1a2537",
                                                borderRadius: '15px',
                                                padding: '30px',
                                                border: "1px solid #D9D9D90D",
                                            }}>


                                                {/* Standard Shipping */}
                                                <Typography variant="subtitle1" sx={{ color: "white", mb: 0, fontFamily: "Maven Pro, sans-serif", fontWeight: 700, fontSize: '20px' }}>
                                                    Standard Shipping
                                                </Typography>
                                                <Grid container spacing={3} sx={{ mb: 3 }}>
                                                    <Grid item xs={12} md={6}>
                                                        <SelectField
                                                            size="small"
                                                            label="Days"
                                                            options={[
                                                                { id: "1-3 Days", name: "1-3 Days" },
                                                                { id: "3-5 Days", name: "3-5 Days" },
                                                                { id: "5-7 Days", name: "5-7 Days" },
                                                            ]}
                                                            selected={selectedStandardDays}

                                                            onSelect={(value) => {

                                                                setSelectedStandardDays(value)
                                                                setValue5('standardDays', value)
                                                            }}
                                                            error={errors5?.standardDays?.message}
                                                            register={register5("standardDays", {
                                                                required: "Please select days",
                                                            })}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            label="In-City Price"
                                                            type={'number'}
                                                            placeholder="Price for In-City Delivery"
                                                            error={errors5?.standardInState?.message}
                                                            register={register5("standardInState", {
                                                                required: "Price is required",
                                                                min: {
                                                                    value: 1,
                                                                    message: "Price must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            label="Out of City Price"
                                                            type="number"
                                                            placeholder="Price for Out-of-State Delivery"
                                                            error={errors5?.standardOutState?.message}
                                                            register={register5("standardOutState", {
                                                                required: "Price is required",
                                                                min: {
                                                                    value: 1,
                                                                    message: "Price must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            type="number"
                                                            label="Shipping Price for Shirts upto"
                                                            placeholder="Shipping Price for Limited Quantity"
                                                            error={errors5?.standardShirts?.message}
                                                            register={register5("standardShirts", {
                                                                required: "Price is required",
                                                                min: {
                                                                    value: 1,
                                                                    message: "Quantity must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                </Grid>

                                                {/* Premium Shipping */}
                                                <Typography variant="subtitle1" sx={{ color: "white", mb: 0, fontFamily: "Maven Pro, sans-serif", fontWeight: 700, fontSize: '20px' }}>
                                                    Premium Shipping
                                                </Typography>
                                                <Grid container spacing={3} sx={{ mb: 3 }}>
                                                    <Grid item xs={12} md={6}>
                                                        <SelectField
                                                            size="small"
                                                            label="Days"
                                                            options={[
                                                                { id: "1-3 Days", name: "1-3 Days" },
                                                                { id: "3-5 Days", name: "3-5 Days" },
                                                                { id: "5-7 Days", name: "5-7 Days" },
                                                            ]}
                                                            selected={selectedPremiumDays}
                                                            onSelect={(value) => {
                                                                setSelectedPremiumDays(value);
                                                                setValue5("premiumDays", value);
                                                            }}
                                                            error={errors5?.premiumDays?.message}
                                                            register={register5("premiumDays", {
                                                                required: anyFieldFilled ? "Days are required" : false,
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            label="In-City Price"
                                                            type="number"
                                                            placeholder="Price for In-City Delivery"
                                                            error={errors5?.premiumInState?.message}
                                                            register={register5("premiumInState", {
                                                                required: anyFieldFilled ? "Price is required" : false,
                                                                min: {
                                                                    value: 1,
                                                                    message: "Price must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            label="Out of City Price"
                                                            type="number"
                                                            placeholder="Price for Out-of-State Delivery"
                                                            error={errors5?.premiumOutState?.message}
                                                            register={register5("premiumOutState", {
                                                                required: anyFieldFilled ? "Price is required" : false,
                                                                min: {
                                                                    value: 1,
                                                                    message: "Price must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            type="number"
                                                            label="Shipping Price for Shirts upto"
                                                            placeholder="Shipping Price for Limited Quantity"
                                                            error={errors5?.premiumShirts?.message}
                                                            register={register5("premiumShirts", {
                                                                required: anyFieldFilled ? "Quantity is required" : false,
                                                                min: {
                                                                    value: 1,
                                                                    message: "Quantity must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                {/* Express Shipping */}
                                                <Typography variant="subtitle1" sx={{ color: "white", mb: 0, fontFamily: "Maven Pro, sans-serif", fontWeight: 700, fontSize: '20px' }}>
                                                    Express Shipping
                                                </Typography>
                                                <Grid container spacing={3} sx={{ mb: 3 }}>
                                                    <Grid item xs={12} md={6}>
                                                        <SelectField
                                                            size="small"
                                                            label="Days"
                                                            options={[
                                                                { id: "1-3 Days", name: "1-3 Days" },
                                                                { id: "3-5 Days", name: "3-5 Days" },
                                                                { id: "5-7 Days", name: "5-7 Days" },
                                                            ]}
                                                            selected={selectedExpressDays}
                                                            onSelect={(value) => {
                                                                setSelectedExpressDays(value);
                                                                setValue5("expressDays", value);
                                                            }}
                                                            error={errors5?.expressDays?.message}
                                                            register={register5("expressDays", {
                                                                required: anyExpressFilled ? "Days are required" : false,
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            type="number"
                                                            label="In-City Price"
                                                            placeholder="Price for In-City Delivery"
                                                            error={errors5?.expressInState?.message}
                                                            register={register5("expressInState", {
                                                                required: anyExpressFilled ? "Price is required" : false,
                                                                min: {
                                                                    value: 1,
                                                                    message: "Price must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            type="number"
                                                            label="Out of City Price"
                                                            placeholder="Price for Out-of-State Delivery"
                                                            error={errors5?.expressOutState?.message}
                                                            register={register5("expressOutState", {
                                                                required: anyExpressFilled ? "Price is required" : false,
                                                                min: {
                                                                    value: 1,
                                                                    message: "Price must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            type="number"
                                                            label="Shipping Price for Shirts upto"
                                                            placeholder="Shipping Price for Limited Quantity"
                                                            error={errors5?.expressShirts?.message}
                                                            register={register5("expressShirts", {
                                                                required: anyExpressFilled ? "Quantity is required" : false,
                                                                min: {
                                                                    value: 1,
                                                                    message: "Quantity must be at least 1",
                                                                },
                                                            })}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            {/* Submit Button */}
                                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        color: "#0BD1D1",
                                                        border: " 2px solid #00BCD4",
                                                        px: 5,
                                                        py: 1.5,
                                                        borderRadius: 4,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        textTransform: "none",

                                                        fontWeight: 600,
                                                        "&:hover": { border: " 2px solid #00BCD4" },
                                                        mr: 2,

                                                    }}
                                                    onClick={() => setActiveStep(3)}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"

                                                    sx={{
                                                        background: "#00BCD4",
                                                        color: "#101A33",
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontWeight: 700,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        px: {
                                                            xs: 2,  // padding-x small on mobile
                                                            sm: 3,
                                                            md: 4,
                                                            lg: 5,  // more padding on larger screens
                                                        },
                                                        py: {
                                                            xs: 1,  // padding-y small on mobile
                                                            sm: 1.2,
                                                            md: 1.5,
                                                        },
                                                        "&:hover": {
                                                            background: "#00ACC1",
                                                        },
                                                    }}

                                                >
                                                    Save & Continue
                                                </Button>
                                            </Box>
                                        </form>

                                    )}

                                    {activeStep === 5 && (
                                        <form onSubmit={handleSubmit6(onSubmit6)} >
                                            <Box sx={{
                                                background: "#1a2537",
                                                borderRadius: '15px',
                                                padding: '30px',
                                                border: "1px solid #D9D9D90D",
                                            }}>
                                                <label style={{ color: '#a3abb2', fontWeight: 600 }}>Upload Past Work / Portfolio</label>

                                                <Grid container spacing={3} mt={0.1}>
                                                    {/* Upload Past Work / Portfolio */}
                                                    <Grid item md={6} xs={12} sx={{ display: "flex", gap: 2, alignItems: "flex-end" }}>
                                                        {/* Upload Box */}
                                                        <Box
                                                            sx={{
                                                                border: "1px dashed white",
                                                                borderRadius: 3,
                                                                p: 4,
                                                                textAlign: "center",
                                                                color: "white",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                backgroundColor: '#3b4d5c',
                                                                minWidth: 50,
                                                                minHeight: 30,
                                                            }}
                                                            onClick={() => document.getElementById("past-work").click()}
                                                        >
                                                            {!loader ? <>
                                                                <Box
                                                                    sx={{
                                                                        width: 24,
                                                                        height: 24,
                                                                        borderRadius: "50%",
                                                                        border: "2px solid white",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        mb: 0,
                                                                    }}
                                                                >
                                                                    <AddIcon sx={{ color: "white", fontSize: '18px' }} />
                                                                </Box>

                                                                <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '14px' }}>
                                                                    Add Image
                                                                </Typography>
                                                            </> : <img
                                                                src={Images.loader}
                                                                alt="Loading..."
                                                                style={{
                                                                    width: "120px",
                                                                    height: "120px",
                                                                    objectFit: "contain",
                                                                }}
                                                            />}


                                                            {/* Hidden Input */}
                                                            <input
                                                                id="past-work"
                                                                type="file"
                                                                accept="image/png, image/jpeg"
                                                                multiple

                                                                hidden
                                                                {...register6("portfolioImages", {
                                                                    required: uploadedImages5?.length > 0 ? false : "Please upload at least one image",
                                                                })}
                                                                onChange={(event) => {
                                                                    const files = event.target.files;
                                                                    if (files.length > 5) {
                                                                        ErrorToaster("You can upload a maximum of 5 images.");
                                                                        event.target.value = ""; // reset the file input
                                                                        return;
                                                                    }

                                                                    handleImageUpload5(event); // Handle file upload
                                                                    setValue6("portfolioImages", files); // RHF
                                                                }}


                                                            />
                                                        </Box>

                                                        {/* Guidelines */}
                                                        <Box sx={{ mb: 0 }}>
                                                            <Typography variant="caption" display="block" sx={{ color: "#9e9e9e" }}>
                                                                PNG or JPG
                                                            </Typography>
                                                            <Typography variant="caption" display="block" sx={{ color: "#9e9e9e" }}>
                                                                Maximum file size of 5mb
                                                            </Typography>
                                                            <Typography variant="caption" display="block" sx={{ color: "#9e9e9e" }}>
                                                                Minimum dimensions of 960px by 960px
                                                            </Typography>
                                                            <Typography variant="caption" display="block" sx={{ color: "#9e9e9e" }}>
                                                                Only 5 images
                                                            </Typography>

                                                            {errors6?.portfolioImages && (
                                                                <Typography variant="caption" color="error">
                                                                    {errors6.portfolioImages.message}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item md={6} xs={12} sx={{ display: "flex", gap: 2, alignItems: "flex-end" }}>
                                                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 2 }}>
                                                            {uploadedImages5.map((img, index) => (
                                                                <Box
                                                                    key={index}
                                                                    sx={{
                                                                        position: "relative",
                                                                        width: 80,
                                                                        height: 80,
                                                                        borderRadius: 2,
                                                                        overflow: "hidden",
                                                                        border: "1px solid rgba(255,255,255,0.2)",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={img}
                                                                        alt={`uploaded-${index}`}
                                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                    />

                                                                    {/* Remove Icon */}
                                                                    <IconButton
                                                                        size="small"
                                                                        sx={{
                                                                            position: "absolute",
                                                                            top: 2,
                                                                            right: 2,
                                                                            background: "rgba(0,0,0,0.6)",
                                                                            color: "white",
                                                                            "&:hover": { background: "rgba(0,0,0,0.8)" },
                                                                        }}
                                                                        onClick={() =>
                                                                            setUploadedImages5((prev) => prev.filter((_, i) => i !== index))
                                                                        }
                                                                    >
                                                                        <CloseIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Grid>
                                                    {/* Add Social Media Links */}
                                                    <Grid item xs={12}>
                                                        <label style={{ color: '#a3abb2', fontWeight: 600 }}>Add Social Media Links</label>
                                                        <Grid container spacing={2} alignItems="center">
                                                            {/* Select Field */}
                                                            <Grid item xs={12} sm={4} md={3}>
                                                                <SelectField
                                                                    size="small"
                                                                    placeholder="Select Link"
                                                                    options={[
                                                                        { id: "Facebook", name: "Facebook", icon: <FacebookIcon sx={{ color: "#0BD1D1" }} /> },
                                                                        { id: "Instagram", name: "Instagram", icon: <InstagramIcon sx={{ color: "#0BD1D1" }} /> },
                                                                        { id: "Twitter", name: "Twitter", icon: <TwitterIcon sx={{ color: "#0BD1D1" }} /> },
                                                                        { id: "LinkedIn", name: "LinkedIn", icon: <LinkedInIcon sx={{ color: "#0BD1D1" }} /> },
                                                                    ]}
                                                                    selected={selectedPlatform}
                                                                    onSelect={(value) => setSelectedPlatform(value)}
                                                                    error={errors6?.socialPlatform?.message}
                                                                    register={register6("socialPlatform", { required: false })}
                                                                />
                                                            </Grid>

                                                            {/* Input Field */}
                                                            <Grid item xs={12} sm={5} md={6}>
                                                                <InputField2
                                                                    placeholder="Web Address"
                                                                    error={errors6?.socialUrl?.message}
                                                                    register={register6("socialUrl", { required: false })}
                                                                />
                                                            </Grid>

                                                            {/* Add Button */}
                                                            <Grid item xs={12} sm={3} md={3}>
                                                                <Button
                                                                    fullWidth
                                                                    variant="contained"
                                                                    sx={{
                                                                        background: "#00BCD4",
                                                                        color: "#0d2c3f",
                                                                        p: 1,
                                                                        py: 1.5,
                                                                        borderRadius: 2,
                                                                        textTransform: "none",
                                                                        fontWeight: 600,
                                                                        "&:hover": { background: "#00ACC1" },
                                                                    }}
                                                                    onClick={handleAddSocialLink}
                                                                >
                                                                    Add
                                                                </Button>
                                                            </Grid>
                                                        </Grid>


                                                        {/* Render added social links */}
                                                        {socialLinks.map((link, index) => (
                                                            <Box
                                                                key={index}
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    mt: 2,
                                                                    p: 2,
                                                                    background: "#192b3c",
                                                                    borderRadius: 2,
                                                                    gap: 2,
                                                                }}
                                                            >
                                                                {console.log(link, 'link')}
                                                                {/* Left Section (Icon + Input) */}
                                                                <Box sx={{ display: "flex", alignItems: "center", flex: 1, gap: 2 }}>
                                                                    {/* Icon */}
                                                                    <Box sx={{ fontSize: "28px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                        {platformIcons[link?.platform?.id?.toLowerCase()]}
                                                                    </Box>

                                                                    {/* Input */}
                                                                    <Box sx={{ width: '100%' }}>
                                                                        <InputField2
                                                                            size="small"
                                                                            fullWidth
                                                                            disabled
                                                                            sx={{
                                                                                "& .MuiInputBase-input.Mui-disabled": {
                                                                                    WebkitTextFillColor: "#9e9e9e", // gray text for disabled state
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    color: "#9e9e9e", // ensures text is gray
                                                                                    fontSize: "15px",
                                                                                },
                                                                            }}
                                                                            value={link.url || ""}
                                                                        />
                                                                    </Box>
                                                                </Box>

                                                                {/* Action Buttons */}
                                                                <Box sx={{ display: "flex", gap: 1 }}>
                                                                    {/* Edit Button */}
                                                                    {/* <IconButton
                                                                        onClick={() => handleEditSocialLink(index)}
                                                                        sx={{
                                                                            background: "#00BCD4",
                                                                            borderRadius: 2,
                                                                            "&:hover": { background: "#00ACC1" },
                                                                            width: 40,
                                                                            height: 40,
                                                                        }}
                                                                    >
                                                                        <img src={Images.editImage} alt="Edit" style={{ width: 20, height: 20 }} />
                                                                    </IconButton> */}

                                                                    {/* Delete Button */}
                                                                    <IconButton
                                                                        onClick={() => handleDeleteSocialLink(index)}
                                                                        sx={{
                                                                            background: "#00BCD4",
                                                                            borderRadius: 2,
                                                                            "&:hover": { background: "#e63946" },
                                                                            width: 40,
                                                                            height: 40,
                                                                        }}
                                                                    >
                                                                        <img src={Images.deleteImage} alt="Delete" style={{ width: 20, height: 20 }} />
                                                                    </IconButton>
                                                                </Box>
                                                            </Box>
                                                        ))}


                                                    </Grid>

                                                    {/* Business Description */}
                                                    <Grid item xs={12}>
                                                        <InputField2
                                                            label="Business Description"
                                                            placeholder="Type Description"
                                                            multiline
                                                            rows={4}

                                                            sx={{

                                                                "& .MuiInputBase-input": {
                                                                    color: "#9e9e9e", // ensures text is gray
                                                                    fontSize: "16px",
                                                                },
                                                            }}
                                                            error={errors6?.businessDescription?.message}
                                                            register={register6("businessDescription", {
                                                                required: "Business description is required",
                                                            })}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            {/* Back & Save Buttons */}

                                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        color: "#0BD1D1",
                                                        border: " 2px solid #00BCD4",
                                                        px: 5,
                                                        py: 1.5,
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },

                                                        fontWeight: 600,
                                                        "&:hover": { border: " 2px solid #00BCD4" },
                                                        mr: 2,

                                                    }}
                                                    onClick={() => setActiveStep(4)}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"

                                                    sx={{
                                                        background: "#00BCD4",
                                                        color: "#101A33",
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontWeight: 700,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        px: {
                                                            xs: 2,  // padding-x small on mobile
                                                            sm: 3,
                                                            md: 4,
                                                            lg: 5,  // more padding on larger screens
                                                        },
                                                        py: {
                                                            xs: 1,  // padding-y small on mobile
                                                            sm: 1.2,
                                                            md: 1.5,
                                                        },
                                                        "&:hover": {
                                                            background: "#00ACC1",
                                                        },
                                                    }}

                                                >
                                                    Save & Continue
                                                </Button>
                                            </Box>
                                        </form>

                                    )}

                                    {activeStep === 6 && (
                                        <form onSubmit={handleSubmit7(onSubmit7)} >
                                            <Box sx={{
                                                background: "#1a2537",
                                                borderRadius: '15px',
                                                padding: '30px',
                                                border: "1px solid #D9D9D90D",
                                            }}>
                                                <Typography variant="h6" sx={{ color: "white", mb: 3, fontWeight: 700, fontSize: '20px' }}>
                                                    Taxation Details
                                                </Typography>

                                                <Grid container spacing={3}>
                                                    {/* Tax Identification Number */}
                                                    <Grid item xs={12} md={6}>
                                                        <InputField2
                                                            label="Tax Identification Number"
                                                            placeholder="Enter Your Tax ID"
                                                            error={errors7?.taxId?.message}
                                                            register={register7("taxId", {
                                                                required: false,
                                                            })}
                                                        />
                                                    </Grid>

                                                    {/* State of Incorporation */}
                                                    <Grid item xs={12} md={6}>
                                                        <SelectField
                                                            size="small"
                                                            label="State of Incorporation"
                                                            options={states}
                                                            selected={selectedState2}

                                                            onSelect={(value) => {

                                                                setSelectedState2(value)
                                                                setValue7('state2', value)
                                                            }}
                                                            error={errors7?.state2?.message}
                                                            register={register7("state2", {
                                                                required: false,
                                                            })}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            {/* Buttons */}

                                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        color: "#0BD1D1",
                                                        border: " 2px solid #00BCD4",
                                                        px: 5,
                                                        py: 1.5,
                                                        borderRadius: 4,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        textTransform: "none",

                                                        fontWeight: 600,
                                                        "&:hover": { border: " 2px solid #00BCD4" },
                                                        mr: 2,

                                                    }}
                                                    onClick={() => setActiveStep(5)}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"

                                                    sx={{
                                                        background: "#00BCD4",
                                                        color: "#101A33",
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontWeight: 700,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        px: {
                                                            xs: 2,  // padding-x small on mobile
                                                            sm: 3,
                                                            md: 4,
                                                            lg: 5,  // more padding on larger screens
                                                        },
                                                        py: {
                                                            xs: 1,  // padding-y small on mobile
                                                            sm: 1.2,
                                                            md: 1.5,
                                                        },
                                                        "&:hover": {
                                                            background: "#00ACC1",
                                                        },
                                                    }}

                                                >
                                                    Save & Continue
                                                </Button>
                                            </Box>
                                        </form>

                                    )}

                                    {activeStep === 7 && (
                                        <form onSubmit={handleSubmit8(onSubmit8)} >

                                            <Box sx={{
                                                background: "#1a2537",
                                                borderRadius: '15px',
                                                padding: '30px',
                                                border: "1px solid #D9D9D90D",
                                            }}>
                                                <label style={{ color: '#a3abb2', fontWeight: 600, fontSize: '15px' }}>Return/Refund Policy Info</label>

                                                <Grid container spacing={3}>
                                                    {/* No. Of Days To Print A Single Product */}
                                                    <Grid item xs={6} mt={2} sx={{ display: "flex", gap: 2, alignItems: "flex-end" }}>
                                                        {/* Upload Box */}
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                                            {/* Upload Box */}
                                                            <Box
                                                                sx={{
                                                                    border: "1px dashed white",
                                                                    borderRadius: 3,
                                                                    p: 4,
                                                                    textAlign: "center",
                                                                    color: "white",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    backgroundColor: "#3b4d5c",
                                                                    width: 170,
                                                                    height: 80,
                                                                }}
                                                                onClick={() => document.getElementById("refund-upload").click()}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        width: 30,
                                                                        height: 30,

                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        mb: 0,
                                                                    }}
                                                                    component={'img'}
                                                                    src={Images.uploadIcon}
                                                                >

                                                                </Box>

                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        fontWeight: 500,
                                                                        fontSize: "14px",
                                                                        mt: 1,
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {"Upload Return/Refund Policy Document"}
                                                                </Typography>

                                                                {/* Hidden Input */}
                                                                <input
                                                                    id="refund-upload"
                                                                    type="file"
                                                                    accept="application/pdf"
                                                                    hidden
                                                                    {...register8("returnDoc", {
                                                                        required: returnDoc ? false : "Please upload pdf",
                                                                    })}
                                                                    onChange={(event) => {

                                                                        handleDocUpload(event);
                                                                        setValue8("returnDoc", event.target.files);
                                                                    }}
                                                                />
                                                            </Box>
                                                            {errors8?.returnDoc && (
                                                                <Typography variant="caption" color="error">
                                                                    {errors8.returnDoc.message}
                                                                </Typography>
                                                            )}
                                                            {/* PDF Icon on Right Side */}
                                                            {returnDoc && (
                                                                <PictureAsPdfIcon
                                                                    sx={{
                                                                        color: "white",
                                                                        fontSize: 40,
                                                                        cursor: "pointer",
                                                                        "&:hover": { transform: "scale(1.1)" },
                                                                    }}
                                                                    onClick={() => window.open(returnDoc[0], "_blank")}
                                                                />
                                                            )}
                                                        </Box>


                                                    </Grid>
                                                    <Grid container spacing={3} p={3} >
                                                        <Grid item xs={12} md={6}>
                                                            <InputField2
                                                                label="No. Of Days To Print A Single Product"
                                                                placeholder="No. Of Days To Print A Single Product"
                                                                error={errors8?.printDays?.message}
                                                                register={register8("printDays", {
                                                                    required: "Number of days is required",
                                                                })}
                                                            />
                                                        </Grid>

                                                        {/* Customer Support Contact Info */}
                                                        <Grid item xs={12} md={6}>
                                                            <InputField2
                                                                label="Customer Support Contact Info"
                                                                placeholder="Phone Number Or Email Field"
                                                                error={errors8?.supportContact?.message}
                                                                register={register8("supportContact", {
                                                                    required: "Contact info is required",
                                                                })}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                {/* Terms & Conditions Checkbox */}
                                                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                                                    <Checkbox
                                                        checked={agree}
                                                        {...register8("agree", {
                                                            required: agree ? false : "You must agree before submitting",
                                                            onChange: (e) => {
                                                                setAgree(e.target.checked); // ✅ still updates your state
                                                            },
                                                        })}
                                                        sx={{
                                                            "& .MuiSvgIcon-root": {
                                                                backgroundColor: "white",
                                                                borderRadius: "6px",
                                                                border: "2px solid #00BCD4",
                                                                fontSize: 20,
                                                                fill: "transparent",
                                                            },
                                                            "&.Mui-checked .MuiSvgIcon-root": {
                                                                backgroundColor: "#1976D2",
                                                                border: "2px solid #1976D2",
                                                                color: "white",
                                                                fill: "white",
                                                            },
                                                        }}
                                                    />





                                                    <Typography variant="body2" sx={{ color: "white" }}>
                                                        By signing up you agree to our{" "}
                                                        <Link onClick={() => setTerms(true)} href="#" style={{ color: "#0BD1D1" }}>
                                                            Terms & Conditions
                                                        </Link>{" "}
                                                        and our{" "}
                                                        <Link href="#" onClick={() => setTerms(true)} style={{ color: "#0BD1D1" }}>
                                                            Privacy Policy
                                                        </Link>
                                                    </Typography>
                                                </Box>
                                                {errors8.agree && (
                                                    <FormHelperText error>{errors8.agree.message}</FormHelperText>
                                                )}
                                            </Box>

                                            {/* Submit Button */}

                                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        color: "#0BD1D1",
                                                        border: " 2px solid #00BCD4",
                                                        px: 5,
                                                        py: 1.5,
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        fontWeight: 600,
                                                        "&:hover": { border: " 2px solid #00BCD4" },
                                                        mr: 2,

                                                    }}
                                                    onClick={() => setActiveStep(6)}
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"

                                                    sx={{
                                                        background: "#00BCD4",
                                                        color: "#101A33",
                                                        borderRadius: 4,
                                                        textTransform: "none",
                                                        fontWeight: 700,
                                                        fontSize: {
                                                            xs: "13px", // mobile
                                                            sm: "14px", // tablets
                                                            md: "15px", // laptops
                                                            lg: "16px", // large screens
                                                        },
                                                        px: {
                                                            xs: 2,  // padding-x small on mobile
                                                            sm: 3,
                                                            md: 4,
                                                            lg: 5,  // more padding on larger screens
                                                        },
                                                        py: {
                                                            xs: 1,  // padding-y small on mobile
                                                            sm: 1.2,
                                                            md: 1.5,
                                                        },
                                                        "&:hover": {
                                                            background: "#00ACC1",
                                                        },
                                                    }}

                                                >
                                                    Submit Registration
                                                </Button>
                                            </Box>
                                        </form>

                                    )}
                                </Box>
                            </Grid>

                        </Grid>
                    </Box>
                </Box>
            </Box>

        </div>
    );
};

export default VendorForm;
